import React, { useContext, useState, useEffect } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import { PostAPI } from "api/post";
import Wizard from './PageType-3.jsx';
import Card from "components/Card/Card.jsx";
import { isEmpty } from "components/Login/validator";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from 'react-bootstrap-table2-paginator';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search, ColumnToggle, CSVExport } from 'react-bootstrap-table2-toolkit';
import { FeatureBlueprintContext } from "context/FeatureBlueprintContext";
import { FetchAPI } from "api/fetch";
import { GlobalLoadIndicator } from "context/GlobalLoadIndicator";
import BeatLoader from "react-spinners/BeatLoader";
import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner";
import SimpleReactValidator from 'simple-react-validator';
import { MDBRow, MDBCol } from 'mdbreact';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/dist/backdrop.css';
import 'tippy.js/themes/light.css';
import 'tippy.js/animations/shift-toward.css';
import 'tippy.js/animations/shift-toward-subtle.css';
import 'tippy.js/animations/shift-toward-extreme.css';
import { useTranslation } from 'react-i18next';
import FilterBox from '../components/FilterBox/FilterBox';
import ButtonField from '../components/UI/Button/ButtonField';
import ModalBox from '../components/ModalBox/ModalBox';
import ModalTreeBox from '../components/ModalBox/ModalTreeBox';
import SortableTree, { getVisibleNodeCount } from "react-sortable-tree"
import FileExplorerTheme from 'react-sortable-tree-theme-full-node-drag';
import treeData from 'views/treeData';
import 'react-sortable-tree/style.css';
import swal from 'sweetalert';
import Cookies from 'universal-cookie';
import { WizardDataContext } from "context/WizardDataContext";
import { getWizardDataService } from "services/wizardDataService.js";
import { getStatusAlert, getReportTotalQuanties } from "../utilities/CommonUtils.js";
const cookies = new Cookies();

const Role = props => {
  const { t, i18n } = useTranslation();
  const initialValue = [{displayValue: `${t('please_select')}`, value: ''}];
  let [featureBlueprint, setFeatureBlueprint] = useContext(FeatureBlueprintContext);
  let [globalLoadIndicator, setGlobalLoadIndicator] = useContext(GlobalLoadIndicator);
  let pageLayoutDataContext = (featureBlueprint.data == undefined) ? 'undefined' : featureBlueprint.data.featureBlueprintymlData.pageTypes[0].bodyLayout;
  let pageType = (featureBlueprint.data == undefined) ? 'undefined' : featureBlueprint.data.featureBlueprintymlData.pageTypes[0];
  let [pageLayoutData, setPageLayoutData] = useState('undefined');
  const { SearchBar, ClearSearchButton } = Search;
  let[commonTitle, setCommonTitle] = useState("");
  let [renderComponent, setRenderComponent] = useState(false);
  let [expandTableLoader, setExpandTableLoader] = useState(false);
  let [expandChildTableLoader, setExpandChildTableLoader] = useState(false);
  let [showParentContent, setShowParentContent] = useState(true);
  let [title1, setTitle1] = useState('')
  let [uniqueid, setuniqueid] = useState();
  let[key, setKey] = useState()
  let[key1, setKey1] = useState()
  let [expRes, setExpRes] = useState();
  let [line,setLine] = useState()
  let [table, setTable] = useState(false);
  let [expand, setExpand] = useState([])
  let [values, setValues] = useState();
  let [headers, setHeaders] = useState(null);
  let [modalTitle, setModalTitle] = useState('');
  let [url, setUrl] = useState();
  const { ToggleList } = ColumnToggle;
  const { ExportCSVButton } = CSVExport;
  let [saveUrl, setSaveUrl] = useState();
  let [extraId, setextraId] = useState();
  let [searchInputValue, setsearchInputValue] = useState();
  let [imagePath, setImagePath] = useState();
  let[array,setArray] = useState([])
  const [showFilter, setshowFilter] = useState(false);
  let [invValidation,setInvValidation] = useState(true)
  const [showCSearch, setshowCSearch] = useState(false);
  const [showModal, setshowModal] = useState(false);
  const [ShowModald3, setShowModald3] = useState(false);
  const [treevalue, setTreevalue] = useState( treeData );
  const [changeTreeValue, setChangeTreeValue] = useState(false);
  const [childRow, setChildRow] = useState(1);
  const [wareId, setWareId] = useState()
  const [selectOption, setSelectOption] = useState(0);
  const [selectedValue, setSelectedValue] = useState("");
  let [loading, setLoading] = useState(false);
  let [loadTableData, setloadTableData] = useState(true);
  let [page, setpage] = useState(1);
  let [expPage, setExpPage] = useState(1);
  let [expChildPage, setExpChildPage] = useState(1);
  let [val1, setVal1] = useState();
  let [val2, setVal2] = useState();
  let [sizePerPage, setsizePerPage] = useState(10);
  let [expSizePerPage, setExpSizePerPage] = useState(10);
  let [expChildSizePerPage, setExpChildSizePerPage] = useState(10);
  let [totalrecords, settotalrecords] = useState();
  let [modalType, setmodalType] = useState(`${t('add')}`);
  let [modalActionURL, setmodalActionURL] = useState('');
  let [modalgetURL, setmodalgetURL] = useState('');
  let [searchInputVlaue, setsearchInputVlaue] = useState();
  let [productsData, setproductsData] = useState([]);
  let [modalWidth, setModalWidth] = useState();
  let [localPageLoadIndicator, setLocalPageLoadIndicator] = useState(globalLoadIndicator);
  let [dropDownApi, setDropDownApi] = useState();
  let [productId, setProductId]= useState();
  let [deliveryId, setDeliveryId]= useState();
  let [locationTypeId, setLocationTypeId]= useState();
  let [locationId, setLocationId]= useState();
  let [errorMsg, setErrorMsg] = useState();
  let [error, setError] = useState(false);
  let [uniqueId, setuniqueId] = useState();
  let[response, setResponse] = useState();
  let [expandRowTotalrecords, setExpRowTotalrecords] = useState()
  let [expandChildRowTotalrecords, setExpChildRowTotalrecords] = useState()
  let [selectChildValue, setSelectChildValue] = useState([]);
  let [showExpandColumn, setshowExpandColumn] = useState(false);
  let [addPermission, setAddPermission] = useState(false)
  let [addPermission1, setAddPermission1] = useState(false)
  let [addChildPermission, setAddChildPermission] = useState(false)
  let [addPermission2, setAddPermission2] = useState(false)
  let [addPermission3, setAddPermission3] = useState(false)
  let [addPermission4, setAddPermission4] = useState(false)
  let [importPermission, setimportPermission] = useState(false)
  let [importPermission1, setimportPermission1] = useState(false)
  let [importPermission2,setimportPermission2] = useState(false)
  let [exportPermission, setexportPermission] = useState(false)
  let [exportPermission1, setexportPermission1] = useState(false)
  let [exportPermission2, setexportPermission2] = useState(false)
  let [exportPermission3, setexportPermission3] = useState(false)
  let[onlyOneExpanding,setonlyOneExpanding]=useState(false);
  let[expandByColumnOnly,setexpandByColumnOnly] = useState(false)
  let[onExpandable,setonExpandable] = useState(true)
  const [wizardData, setWizardData] = useContext(WizardDataContext)
  let headerData = {
     start_from: 0,
     customer_id:cookies.get('customer_id'),
     user_id:cookies.get('user_id'),
  }
  const languages = [
    {
      code: 'en',
      name: 'English',
      country_code: 'gb',
    },
    {
      code: 'chi',
      name: '中国人',
      country_code: 'cn',
    }
  ];
  const rowStyle = (row) => {
    const po_condition = row?.po_type === 'Reclamation PO'
    const backgroundColor = po_condition && '#B9D9EB';
    const color = po_condition && 'black';
    return { backgroundColor, color };
  };
  const currentLanguageCode = localStorage.getItem('i18nextLng') || 'english'
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
  const language = currentLanguageCode === 'en' ? 'english' : 'chinese'
  let dynamicParameters = {
    customer_id:cookies.get('customer_id'),
    user_id:cookies.get('user_id'),
    userLocation_id:cookies.get('userLocation_id'),
    userRole_name:cookies.get('userRole_name'),
    language: currentLanguageCode === 'en' ? 'english' : 'chinese'
 }
 let centeredDiv = {
  display: 'flex',
  alignItems: 'center',
  marginRight:'40%',
  justifyContent: 'center',
  height: '30vh'
}
 let [expandData, setExpData] = useState([])
 let [expChildData, setExpChildData] = useState([]);
  let [columns, setColumns] = useState([{ dataField: "serial_no", text: "Serial No." },
  { dataField: "role_name", text: "Role Name" },
  { dataField: "customer_name", text: "Customer Name" } ]);
  let [expandColumns, setExpColumns] = useState([{ dataField: "serial_no", text: "Serial No." },
  { dataField: "role_name", text: "Role Name" },
  { dataField: "customer_name", text: "Customer Name" }]);
  let [expChildColumns, setExpChildColumns] = useState([{ dataField: "serial_no", text: "Serial No." },
  { dataField: "role_name", text: "Role Name" },
  { dataField: "customer_name", text: "Customer Name" }]);
  let [formValues, setformValues] = useState();
  let [ModalformValues, setModalformValues] = useState();
  let [localSearch, setLocalSearch] = useState(false);
  const count = getVisibleNodeCount({treeData:treevalue})
  const [disableRefreshIcon, setDisableRefreshIcon] = useState(false)
  const [fifoId, setFifoId] = useState()
  let [isLoader, setIsLoader] = useState(false)
  const [bulkPicklistPermission, setBulklistPermission] = useState(false);
  const [masterDeliveryPermission, setMasterDeliveryPermission] = useState(false);
  const [isSelectedRow, setIsSelectedRow] = useState([])
  const [totalQuantities, setTotalQuanties] = useState([])


  const validator = new SimpleReactValidator({
    autoForceUpdate: this,
    element: (message, className) => <div className="text-danger">{message}</div>
  });

  const formElementsArray = [];
  for (let key in ModalformValues) {
    formElementsArray.push({
      id: key,
      config: ModalformValues[key]
    });
  }

  const inputChangedHandler = (event, inputIdentifier) => {
    const updateOrderForm = {
      ...formValues
    }
    const updateElemetForm = {
      ...updateOrderForm[inputIdentifier]
    };

    updateElemetForm.value = event.target.value;
    updateOrderForm[inputIdentifier] = updateElemetForm;
    setformValues(updateOrderForm);
  }


function serachFliterBoxData(data){

  let searchFormData = {}

  if(data){
    for (let formElementIdentifier in data) {
      if(data[formElementIdentifier].elementType === 'multiselect') {
          let multiselectData =   data[formElementIdentifier].value?.map((fValue, indexId)=> {
            return   fValue.value;
            });
            searchFormData[formElementIdentifier] = multiselectData;
        }
        else{
          searchFormData[formElementIdentifier] = data[formElementIdentifier].value;
        }
      }
  }
  

  return searchFormData;
}

  async function instantValuesUpdateFilterBox() {
    let url = pageLayoutData[0].filterEndPoint+'?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id')+'&userLocation_id='+ cookies.get('userLocation_id')+ '&userRole_name='+ cookies.get('userRole_name') + '&language=' + language + '&start_from='+ headerData.start_from
    let getdrpdwnresponse = await FetchAPI(url);
    const getdrpdwnresponseJson = await getdrpdwnresponse.json();
    const updateForm = {
        ...formValues
    }
    const dropVal = {
        ...getdrpdwnresponseJson.data
    }
    let obj;
    obj = Object.keys(getdrpdwnresponseJson.data).forEach((el) => {
        if( Object.keys(el, updateForm)){
          if(!isEmpty(dropVal[el])){
              if(updateForm[el].elementType == 'select'){
                  updateForm[el].elementConfig.options = dropVal[el];
                  updateForm[el].elementConfig.options.splice(0, 0, ...initialValue)
              }
              else if(updateForm[el].elementType == 'multiselect') {
                  updateForm[el].elementConfig.options = dropVal[el];
              }   
          }
          else
          {
              if(updateForm[el].elementType == 'select' )
              updateForm[el].elementConfig.options = initialValue;
              if(updateForm[el].elementType == 'multiselect' )
              updateForm[el].elementConfig.options = null;
          }
        }
        setformValues(updateForm);
      })
    }

  async function searchTableData(data) {
    setloadTableData(false);
    let title1 = i18n.language == "chi" ? pageLayoutData[1].title1En : pageLayoutData[1].title1
    let startFrom = 0;
    let cpage = 0
    const searchFormData = {};
    let totalParams;
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
    if(title1 !== 'Location' && pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    totalParams = {...totalParams, ...dynamicParameters}
    let fmData = serachFliterBoxData(data);
      totalParams.start_from = startFrom;
        let newObj = { ...searchFormData, ...totalParams,...fmData}



    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      let paramsConverted = new URLSearchParams(newObj);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      if(!setsearchInputValue || searchInputValue === undefined )
      getURL = getURL;
      else
      getURL = getURL + '&element=' + searchInputValue;
      let responseData = await FetchAPI(getURL);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
        for (let i = 0; i < responseDataJson.data.data.length; i++) {
          if (responseDataJson?.data?.data[i]?.childData?.length === 0) {
            array.push(responseDataJson.data.data[i].name);
          }
        }
        setArray(array)
          if(!isEmpty(responseDataJson.data.data)) {
            const customerIds = dynamicParameters.customer_id == 14 || dynamicParameters.customer_id == 13;
          for (let [key, value] of Object.entries(responseDataJson.data.data)) {
            /*below condition is for pidilite delivery details */
            if(value?.status === "Cancelled"){
              continue;
            }
            value.actions =  <div>
                  {(pageLayoutData[1].title1 !== "Products") && (pageLayoutData[1].title1 !== "Inventory") && (value?.childData?.length > 0) ? <a onClick={(e) => openModalTreeView(e, value)}><i className="fa fa-expand"></i></a> : ''}
                  {(value.add == true || value[`add${pageLayoutData[0].hasOwnProperty('addButtonParentName') && pageLayoutData[0].addButtonParentName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonParentName.replace(/\s+/g, '') : pageLayoutData[0].addButtonParentName
                    }Permission`] === true) && <a onClick={(e) => opneParent(e, value)}><i className="fa fa-plus-square-o fa-add"></i></a>}
                  {(value.edit == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true) && <a onClick={(e) => editOpenModal(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {(value.del == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true|| value[`delete${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
                  }Permission`] === true) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value.editExtra == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildExtraName') && pageLayoutData[0].addButtonChildExtraName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildExtraName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildExtraName
                    }Permission`] === true) && <a onClick={(e) => editOpenModalExtra(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {responseDataJson.data.editPermission == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => editComponent(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a> : ''}
                  {responseDataJson.data.deletePermission == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => deleteparent1(e, value)}><i className="fa fa-trash-o fa-delete"></i></a> : ''}
                  {customerIds && pageLayoutData[1].title1 == "Delivery" ? (value.fifo_flag == 1) ? <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> : <i onClick={() => handleRefreshIcon(value.name)} className="fa fa-refresh + refresh-icon"></i>
                    : (value.download == true) && <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> }
                  {(value.restore == true) && <a onClick={(e) => restoreParent(e, value)}><i className="fa fa-recycle"></i></a>}
                  {(value.po_type === 'Reclamation PO') &&
                  <Tippy interactive={false} offset={[20, 10]} delay={50} placement={"top"} theme={'light'} animation='shift-toward' content={<div>
                  <h5 style={{ height: '20px', width: '8rem', fontSize: "15px" }}>{pageLayoutData[0].addButtonChildName}</h5></div>}>
                  <i className="fa fa-info-circle info-icon"></i></Tippy>}
                  {(value.master_delivery === 1 && value.DeleteMasterDeliveryPermission) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value?.tp_download === "1" && value.tp_id) && <i className="fa fa-file-pdf-o refresh-icon" aria-hidden="true" onClick={() => handleTpPdfDownload(value)} />}
              </div>;
              if(value.image){
                value.image = <div>
                 <img src={value.image} alt="no img" width="50" height="50" />
                 </div>;
               }
            }
          }
        setpage(1);
        setSelectedValue(1);
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties)
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setloadTableData(true);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }  
    }
    else {
     let newestObj;
     if(!setsearchInputValue || searchInputValue === undefined )
     newestObj = {...newObj}
     else
     newestObj = {...newObj, element:searchInputValue}
      let responseData = await PostAPI(getURL, newestObj);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = responseData.data;
        for (let i = 0; i < responseDataJson.data.data.length; i++) {
          expand.push(responseDataJson.data.data[i].name);
        }
        setArray(array)
        setExpand(expand)
        setResponse(responseDataJson.data.data)
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        if(!isEmpty(responseDataJson.data.data)) {
          const customerIds = dynamicParameters.customer_id == 14 || dynamicParameters.customer_id == 13;
          for (let [key, value] of Object.entries(responseDataJson.data.data)) {
            /*below condition is for pidilite delivery details */
            if(value?.status === "Cancelled"){
              continue;
            }
            value.actions =  <div> 
                  {(pageLayoutData[1].title1 !== "Products") && (pageLayoutData[1].title1 !== "Inventory") && (value?.childData?.length > 0) ? <a onClick={(e) => openModalTreeView(e, value)}><i className="fa fa-expand"></i></a> : ''}
                  {(value.add == true || value[`add${pageLayoutData[0].hasOwnProperty('addButtonParentName') && pageLayoutData[0].addButtonParentName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonParentName.replace(/\s+/g, '') : pageLayoutData[0].addButtonParentName
                    }Permission`] === true) && <a onClick={(e) => opneParent(e, value)}><i className="fa fa-plus-square-o fa-add"></i></a>}
                  {(value.edit == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true) && <a onClick={(e) => editOpenModal(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {(value.del == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
                  }Permission`] === true) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value.editExtra == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildExtraName') && pageLayoutData[0].addButtonChildExtraName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildExtraName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildExtraName
                    }Permission`] === true) && <a onClick={(e) => editOpenModalExtra(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {responseDataJson.data.editPermission == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => editComponent(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a> : ''}
                  {responseDataJson.data.deletePermission == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => deleteparent1(e, value)}><i className="fa fa-trash-o fa-delete"></i></a> : ''}
                  {customerIds && pageLayoutData[1].title1 == "Delivery" ? (value.fifo_flag == 1) ? <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> : <i onClick={() => handleRefreshIcon(value.name)} className="fa fa-refresh + refresh-icon"></i>
                    : (value.download == true) && <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> }
                  {(value.restore == true) && <a onClick={(e) => restoreParent(e, value)}><i className="fa fa-recycle"></i></a>}
                  {(value.po_type === 'Reclamation PO') &&
                  <Tippy interactive={false} offset={[20, 10]} delay={50} placement={"top"} theme={'light'} animation='shift-toward' content={<div>
                  <h5 style={{ height: '20px', width: '8rem', fontSize: "15px" }}>{pageLayoutData[0].addButtonChildName}</h5></div>}>
                  <i className="fa fa-info-circle info-icon"></i></Tippy>}
                  {(value.master_delivery === 1 && value.DeleteMasterDeliveryPermission) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value?.tp_download === "1" && value.tp_id) && <i className="fa fa-file-pdf-o refresh-icon" aria-hidden="true" onClick={() => handleTpPdfDownload(value)} />}
              </div>;
              if(value.image){
                value.image = <div>
                 <img src={value.image} alt="no img" width="50" height="50" />
                 </div>;
               }
          }
        }
        setpage(1);
        setSelectedValue(1);
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties)
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setloadTableData(true);
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }
    }

  }

  async function handleTpPdfDownload(value) {
    setshowExpandColumn(false)
    setIsLoader(true);
    FetchAPI(
      `${pageLayoutData[1].subComponentsItems.tpReportPdfEndpoint}?delivery_id=${value.id}&customer_id=${cookies.get("customer_id")}&user_id=${cookies.get("user_id")}&tp_id=${value.tp_id}`
    )
      .then(responseJson => responseJson.json())
      .then((response) => {
        setIsLoader(false);
        const url = response.data.data
        const link = document.createElement('a');
        link.target = '_self';
        link.href = url;
        link.setAttribute("download", url);
        link.click();
      })
  }

  async function exportPdf(e, id) {
    setshowExpandColumn(false)
    e.preventDefault();
    setIsLoader(true);
    FetchAPI(`${pageLayoutData[0].exportEndPoint}?delivery_id=${id}&customer_id=${cookies.get("customer_id")}&user_id=${cookies.get("user_id")}`)
.then(responseJson => responseJson.json())
.then((response) => {
  setIsLoader(false);
     const url = response.data.data
            const link = document.createElement('a');
            link.target = '_self';
            link.href = url;
            link.setAttribute('download', url);
            link.click();
})
  }

  const deliveryFifoFunc = async(id) => {
    const payloadObj = {
      id: id,
      user_id: cookies.get("user_id")
    }
    setIsLoader(true)
    const getURL = pageLayoutData[0].refreshEndPoint;
    const response = await PostAPI(getURL,payloadObj)
    if(response.status == 200) {
      setIsLoader(false)
      setDisableRefreshIcon(false)
      if(response.data.data.status == 1){
        swal({text:`${t(`${response.data.data.message}`)}`, icon: "success", button:`${t("alerts.ok")}`}) 
        getLatestTableData()
      }else{
        swal({
        icon:"warning",
        text:`${t(`${response.data.data.message}`)}`,
        buttons: `${t('alerts.ok')}`,
         dangerMode: true,
        })
      }
    }else {
      swal({title:`${t("Oops..! Something went wrong.")}`,
        icon:"warning",
        buttons: `${t('alerts.ok')}`,
         dangerMode: true,
        })
    }
  }

  const handleRefreshIcon =  (id) => {
    setshowExpandColumn(false)
    setDisableRefreshIcon(true)
    setFifoId(id)
  }

  useEffect(() => {
    if(fifoId != undefined && disableRefreshIcon){
      deliveryFifoFunc(fifoId)
    }
  },[fifoId,disableRefreshIcon])

  async function filteredExport2(data) {
    setValues(data)
  }
  async function clearTableData(event) {
    setloadTableData(false);
    const searchFormData = {};
    let totalParams;
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    if(pageLayoutData[1].subComponentsItems.firstTimeParameters !== null) {
      const firstTimeParameters = pageLayoutData[1].subComponentsItems.firstTimeParameters;
      totalParams = {...totalParams, ...firstTimeParameters}
    }
    totalParams = {...totalParams, ...dynamicParameters}

    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      let paramsConverted = new URLSearchParams(totalParams);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      if(!setsearchInputValue || searchInputValue === undefined )
      getURL = getURL;
      else
      getURL = getURL + '&element=' + searchInputValue;
      let responseData = await FetchAPI(getURL);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
        for (let i = 0; i < responseDataJson.data.data.length; i++) {
          if (responseDataJson?.data?.data[i]?.childData?.length === 0) {
            array.push(responseDataJson.data.data[i].name);
          }
        }
        setArray(array)
          if(!isEmpty(responseDataJson.data.data)) {
            const customerIds = dynamicParameters.customer_id == 14 || dynamicParameters.customer_id == 13;
          for (let [key, value] of Object.entries(responseDataJson.data.data)) {
            /*below condition is for pidilite delivery details */
            if(value?.status === "Cancelled"){
              continue;
            }
            value.actions =  <div> 
                  {(pageLayoutData[1].title1 !== "Products") && (pageLayoutData[1].title1 !== "Inventory") && (value?.childData?.length > 0) ? <a onClick={(e) => openModalTreeView(e, value)}><i className="fa fa-expand"></i></a> : ''}
                  {(value.add == true || value[`add${pageLayoutData[0].hasOwnProperty('addButtonParentName') && pageLayoutData[0].addButtonParentName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonParentName.replace(/\s+/g, '') : pageLayoutData[0].addButtonParentName
                    }Permission`] === true) && <a onClick={(e) => opneParent(e, value)}><i className="fa fa-plus-square-o fa-add"></i></a>}
                  {(value.edit == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true) && <a onClick={(e) => editOpenModal(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {(value.del == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
                  }Permission`] === true) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value.editExtra == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildExtraName') && pageLayoutData[0].addButtonChildExtraName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildExtraName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildExtraName
                    }Permission`] === true) && <a onClick={(e) => editOpenModalExtra(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {responseDataJson.data.editPermission == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => editComponent(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a> : ''}
                  {responseDataJson.data.deletePermission == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => deleteparent1(e, value)}><i className="fa fa-trash-o fa-delete"></i></a> : ''}
                  {customerIds && pageLayoutData[1].title1 == "Delivery" ? (value.fifo_flag == 1) ? <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> : <i onClick={() => handleRefreshIcon(value.name)} className="fa fa-refresh + refresh-icon"></i>
                    : (value.download == true) && <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> }
                  {(value.restore == true) && <a onClick={(e) => restoreParent(e, value)}><i className="fa fa-recycle"></i></a>}
                  {(value.po_type === 'Reclamation PO') &&
                  <Tippy interactive={false} offset={[20, 10]} delay={50} placement={"top"} theme={'light'} animation='shift-toward' content={<div>
                  <h5 style={{ height: '20px', width: '8rem', fontSize: "15px" }}>{pageLayoutData[0].addButtonChildName}</h5></div>}>
                  <i className="fa fa-info-circle info-icon"></i></Tippy>}
                  {(value.master_delivery === 1 && value.DeleteMasterDeliveryPermission) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value?.tp_download === "1" && value.tp_id) && <i className="fa fa-file-pdf-o refresh-icon" aria-hidden="true" onClick={() => handleTpPdfDownload(value)} />}
              </div>;
              if(value.image){
                value.image = <div>
                 <img src={value.image} alt="no img" width="50" height="50" />
                 </div>;
               }
            }
            
          }
        setpage(1);
        setSelectedValue(1);
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties)
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setloadTableData(true);
        setValues();
        setformValues(pageLayoutData[0].formValues);
        setshowFilter(!showFilter);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }  
    }
    else {
     let newestObj;
     if(!setsearchInputValue || searchInputValue === undefined )
     newestObj = {...totalParams}
     else
     newestObj = {...totalParams, element:searchInputValue}
      let responseData = await PostAPI(getURL, newestObj);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = responseData.data;
        for (let i = 0; i < responseDataJson.data.data.length; i++) {
          expand.push(responseDataJson.data.data[i].name);
        }
        setArray(array)
        setExpand(expand)
        setResponse(responseDataJson.data.data)
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        if(!isEmpty(responseDataJson.data.data)) {
          const customerIds = dynamicParameters.customer_id == 14 || dynamicParameters.customer_id == 13;
          for (let [key, value] of Object.entries(responseDataJson.data.data)) {
            /*below condition is for pidilite delivery details */
            if(value?.status === "Cancelled"){
              continue;
            }
            value.actions =  <div> 
                  {(pageLayoutData[1].title1 !== "Products") && (pageLayoutData[1].title1 !== "Inventory") && (value?.childData?.length > 0) ? <a onClick={(e) => openModalTreeView(e, value)}><i className="fa fa-expand"></i></a> : ''}
                  {(value.add == true || value[`add${pageLayoutData[0].hasOwnProperty('addButtonParentName') && pageLayoutData[0].addButtonParentName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonParentName.replace(/\s+/g, '') : pageLayoutData[0].addButtonParentName
                    }Permission`] === true) && <a onClick={(e) => opneParent(e, value)}><i className="fa fa-plus-square-o fa-add"></i></a>}
                  {(value.edit == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true) && <a onClick={(e) => editOpenModal(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {(value.del == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
                  }Permission`] === true) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value.editExtra == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildExtraName') && pageLayoutData[0].addButtonChildExtraName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildExtraName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildExtraName
                    }Permission`] === true) && <a onClick={(e) => editOpenModalExtra(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {responseDataJson.data.editPermission == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => editComponent(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a> : ''}
                  {responseDataJson.data.deletePermission == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => deleteparent1(e, value)}><i className="fa fa-trash-o fa-delete"></i></a> : ''}
                  {customerIds && pageLayoutData[1].title1 == "Delivery" ? (value.fifo_flag == 1) ? <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> : <i onClick={() => handleRefreshIcon(value.name)} className="fa fa-refresh + refresh-icon"></i>
                    : (value.download == true) && <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> }
                  {(value.restore == true) && <a onClick={(e) => restoreParent(e, value)}><i className="fa fa-recycle"></i></a>}
                  {(value.po_type === 'Reclamation PO') &&
                  <Tippy interactive={false} offset={[20, 10]} delay={50} placement={"top"} theme={'light'} animation='shift-toward' content={<div>
                  <h5 style={{ height: '20px', width: '8rem', fontSize: "15px" }}>{pageLayoutData[0].addButtonChildName}</h5></div>}>
                  <i className="fa fa-info-circle info-icon"></i></Tippy>}
                  {(value.master_delivery === 1 && value.DeleteMasterDeliveryPermission) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value?.tp_download === "1" && value.tp_id) && <i className="fa fa-file-pdf-o refresh-icon" aria-hidden="true" onClick={() => handleTpPdfDownload(value)} />}
              </div>;
              if(value.image){
                value.image = <div>
                 <img src={value.image} alt="no img" width="50" height="50" />
                 </div>;
               }
          }
        }
        setpage(1);
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties)
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setloadTableData(true);
        setValues();
        setformValues(pageLayoutData[0].formValues);
        setshowFilter(!showFilter);
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }
    }
  }

  async function getLatestTableData() {
    setformValues(pageLayoutData[0].formValues);
    setChangeTreeValue(false);
    if(pageLayoutData[0].filterStatusDefault === true)
    setshowFilter(true);
    else
    setshowFilter(false);
    setloadTableData(false);
    setsearchInputValue();
    setshowCSearch(false);
    let totalParams;
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    if(pageLayoutData[1].subComponentsItems.firstTimeParameters !== null) {
      const firstTimeParameters = pageLayoutData[1].subComponentsItems.firstTimeParameters;
      totalParams = {...totalParams, ...firstTimeParameters}
    }
    totalParams = {...totalParams, ...dynamicParameters}

    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      let paramsConverted = new URLSearchParams(totalParams);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      getURL = getURL + '&index=' + page;
      let responseData = await FetchAPI(getURL);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
        array = [];
        for (let i = 0; i < responseDataJson.data.data.length; i++) {
          if (responseDataJson?.data?.data[i]?.childData?.length === 0) {
            array.push(responseDataJson.data.data[i].name);
          }
        }
        setArray(array)
        if(!isEmpty(responseDataJson.data.data)) {
          const customerIds = dynamicParameters.customer_id == 14 || dynamicParameters.customer_id == 13;
             for (let [key, value] of Object.entries(responseDataJson.data.data)) {
              /*below condition is for pidilite delivery details */
              if(value?.status === "Cancelled"){
                continue;
              }
        value.actions =  <div> 
                  {(pageLayoutData[1].title1 !== "Products") && (pageLayoutData[1].title1 !== "Inventory") && (value?.childData?.length > 0) ? <a onClick={(e) => openModalTreeView(e, value)}><i className="fa fa-expand"></i></a> : ''}
                  {(value.add == true || value[`add${pageLayoutData[0].hasOwnProperty('addButtonParentName') && pageLayoutData[0].addButtonParentName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonParentName.replace(/\s+/g, '') : pageLayoutData[0].addButtonParentName
                    }Permission`] === true) && <a onClick={(e) => opneParent(e, value)}><i className="fa fa-plus-square-o fa-add"></i></a>}
                  {(value.edit == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true) && <a onClick={(e) => editOpenModal(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {(value.del == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
                  }Permission`] === true) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value.editExtra == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildExtraName') && pageLayoutData[0].addButtonChildExtraName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildExtraName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildExtraName
                    }Permission`] === true) && <a onClick={(e) => editOpenModalExtra(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {responseDataJson.data.editPermission == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => editComponent(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a> : ''}
                  {responseDataJson.data.deletePermission == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => deleteparent1(e, value)}><i className="fa fa-trash-o fa-delete"></i></a> : ''}
                  {customerIds && pageLayoutData[1].title1 == "Delivery" ? (value.fifo_flag == 1) ? <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> : <i onClick={() => handleRefreshIcon(value.name)} className="fa fa-refresh + refresh-icon"></i>
                    : (value.download == true) && <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> }
                  {(value.restore == true) && <a onClick={(e) => restoreParent(e, value)}><i className="fa fa-recycle"></i></a>}
                  {(value.po_type === 'Reclamation PO') &&
                  <Tippy interactive={false} offset={[20, 10]} delay={50} placement={"top"} theme={'light'} animation='shift-toward' content={<div>
                  <h5 style={{ height: '20px', width: '8rem', fontSize: "15px" }}>{pageLayoutData[0].addButtonChildName}</h5></div>}>
                  <i className="fa fa-info-circle info-icon"></i></Tippy>}
                  {(value.master_delivery === 1 && value.DeleteMasterDeliveryPermission) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value?.tp_download === "1" && value.tp_id) && <i className="fa fa-file-pdf-o refresh-icon" aria-hidden="true" onClick={() => handleTpPdfDownload(value)} />}
          </div>;
           if(value.image){
             value.image = <div>
              <img src={value.image} alt="no img" width="50" height="50" />
              </div>;
            }
      }
 
        }
        setpage(1);
        setSelectedValue(1);
        setColumns(responseDataJson.data.columns);
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setloadTableData(true);
        setformValues(pageLayoutData[0].formValues);
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }  
    }
    else {
      let newObj = {...totalParams, index:page}
      let responseData = await PostAPI(getURL, newObj);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = responseData.data;
        for (let i = 0; i < responseDataJson.data.data.length; i++) {
          expand.push(responseDataJson.data.data[i].name);
        }
        setExpand(expand)
        setResponse(responseDataJson.data.data)
        if(!isEmpty(responseDataJson.data.data)) {
         const customerIds = dynamicParameters.customer_id == 14 || dynamicParameters.customer_id == 13;
            for (let [key, value] of Object.entries(responseDataJson.data.data)) {
              /*below condition is for pidilite delivery details */
            if(value?.status === "Cancelled"){
              continue;
            }
        value.actions =  <div> 
                  {(pageLayoutData[1].title1 !== "Products") && (pageLayoutData[1].title1 !== "Inventory") && (value?.childData?.length > 0) ? <a onClick={(e) => openModalTreeView(e, value)}><i className="fa fa-expand"></i></a> : ''}
                  {(value.add == true || value[`add${pageLayoutData[0].hasOwnProperty('addButtonParentName') && pageLayoutData[0].addButtonParentName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonParentName.replace(/\s+/g, '') : pageLayoutData[0].addButtonParentName
                    }Permission`] === true) && <a onClick={(e) => opneParent(e, value)}><i className="fa fa-plus-square-o fa-add"></i></a>}
                  {(value.edit == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true) && <a onClick={(e) => editOpenModal(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {(value.del == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
                  }Permission`] === true) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value.editExtra == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildExtraName') && pageLayoutData[0].addButtonChildExtraName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildExtraName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildExtraName
                    }Permission`] === true) && <a onClick={(e) => editOpenModalExtra(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {responseDataJson.data.editPermission == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => editComponent(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a> : ''}
                  {responseDataJson.data.deletePermission == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => deleteparent1(e, value)}><i className="fa fa-trash-o fa-delete"></i></a> : ''}
                  {customerIds && pageLayoutData[1].title1 == "Delivery" ? (value.fifo_flag == 1) ? <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> : <i onClick={() => handleRefreshIcon(value.name)} className="fa fa-refresh + refresh-icon"></i>
                    : (value.download == true) && <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> }
                  {(value.restore == true) && <a onClick={(e) => restoreParent(e, value)}><i className="fa fa-recycle"></i></a>}
                  {(value.po_type === 'Reclamation PO') &&
                  <Tippy interactive={false} offset={[20, 10]} delay={50} placement={"top"} theme={'light'} animation='shift-toward' content={<div>
                  <h5 style={{ height: '20px', width: '8rem', fontSize: "15px" }}>{pageLayoutData[0].addButtonChildName}</h5></div>}>
                  <i className="fa fa-info-circle info-icon"></i></Tippy>}
                  {(value.master_delivery === 1 && value.DeleteMasterDeliveryPermission) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value?.tp_download === "1" && value.tp_id) && <i className="fa fa-file-pdf-o refresh-icon" aria-hidden="true" onClick={() => handleTpPdfDownload(value)} />}
        </div>;
           if(value.image){
             value.image = <div>
              <img src={value.image} alt="no img" width="50" height="50" />
              </div>;
            }
      }

        }
        setpage(1);
        setColumns(responseDataJson.data.columns);
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setloadTableData(true);
        setformValues(pageLayoutData[0].formValues);
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }
    }
    setloadTableData(true);
  }

  const handleTableChange = (event, { page, sizePerPage }) => {
    if (event == 'search') {
      return;
    }
    const currentIndex = (page - 1) * sizePerPage;
    setpage(page);
    setsizePerPage(sizePerPage);
    handlePageChange(page);
  }

  async function handleLatestTableData(page) {
    setloadTableData(false);
    let startFrom = 0;
    let cpage = 0
    const searchFormData = {};
    let totalParams;
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    totalParams = {...totalParams, ...dynamicParameters}
    let fmData = serachFliterBoxData(values);
    if(page == 1) {
      let startFrom = 0;
      totalParams.start_from = startFrom;
    }else {
      cpage = page -1;
      startFrom = cpage * sizePerPage;
      totalParams.start_from = startFrom;
    }
    let newObj = { ...fmData, ...totalParams}
    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      let paramsConverted = new URLSearchParams(newObj);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      if(!setsearchInputValue || searchInputValue === undefined )
      getURL = getURL + '&index=' + page;
      else
      getURL = getURL + '&element=' + searchInputValue+'&index=' + page;
      let responseData = await FetchAPI(getURL);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
        for (let i = 0; i < responseDataJson.data.data.length; i++) {
          if (responseDataJson?.data?.data[i]?.childData?.length === 0) {
            array.push(responseDataJson.data.data[i].name);
          }
        }
        setArray(array)
        if(!isEmpty(responseDataJson.data.data)) {
          const customerIds = dynamicParameters.customer_id == 14 || dynamicParameters.customer_id == 13;
          for (let [key, value] of Object.entries(responseDataJson.data.data)) {
            /*below condition is for pidilite delivery details */
            if(value?.status === "Cancelled"){
              continue;
            }
        value.actions =  <div> 
                  {(pageLayoutData[1].title1 !== "Products") && (pageLayoutData[1].title1 !== "Inventory") && (value?.childData?.length > 0) ? <a onClick={(e) => openModalTreeView(e, value)}><i className="fa fa-expand"></i></a> : ''}
                  {(value.add == true || value[`add${pageLayoutData[0].hasOwnProperty('addButtonParentName') && pageLayoutData[0].addButtonParentName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonParentName.replace(/\s+/g, '') : pageLayoutData[0].addButtonParentName
                    }Permission`] === true) && <a onClick={(e) => opneParent(e, value)}><i className="fa fa-plus-square-o fa-add"></i></a>}
                  {(value.edit == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true) && <a onClick={(e) => editOpenModal(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {(value.del == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
                  }Permission`] === true) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value.editExtra == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildExtraName') && pageLayoutData[0].addButtonChildExtraName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildExtraName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildExtraName
                    }Permission`] === true) && <a onClick={(e) => editOpenModalExtra(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {responseDataJson.data.editPermission == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => editComponent(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a> : ''}
                  {responseDataJson.data.deletePermission == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => deleteparent1(e, value)}><i className="fa fa-trash-o fa-delete"></i></a> : ''}
                  {customerIds && pageLayoutData[1].title1 == "Delivery" ? (value.fifo_flag == 1) ? <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> : <i onClick={() => handleRefreshIcon(value.name)} className="fa fa-refresh + refresh-icon"></i>
                    : (value.download == true) && <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> }
                  {(value.restore == true) && <a onClick={(e) => restoreParent(e, value)}><i className="fa fa-recycle"></i></a>}
                  {(value.po_type === 'Reclamation PO') &&
                  <Tippy interactive={false} offset={[20, 10]} delay={50} placement={"top"} theme={'light'} animation='shift-toward' content={<div>
                  <h5 style={{ height: '20px', width: '8rem', fontSize: "15px" }}>{pageLayoutData[0].addButtonChildName}</h5></div>}>
                  <i className="fa fa-info-circle info-icon"></i></Tippy>}
                  {(value.master_delivery === 1 && value.DeleteMasterDeliveryPermission) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value?.tp_download === "1" && value.tp_id) && <i className="fa fa-file-pdf-o refresh-icon" aria-hidden="true" onClick={() => handleTpPdfDownload(value)} />}
           </div>;
           if(value.image){
             value.image = <div>
              <img src={value.image} alt="no img" width="50" height="50" />
              </div>;
            }
      }
        }
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setloadTableData(true);
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }  
    }
    else {
      let newestObjSearch;
      let newestObj = {...newObj, index:page}
      if(!setsearchInputValue || searchInputValue === undefined )
      newestObjSearch = {...newestObj}
      else
      newestObjSearch = {...newestObj, element:searchInputValue}
      let responseData = await PostAPI(getURL, newestObjSearch);
      let responseDataJson = responseData.data;
      for (let i = 0; i < responseDataJson.data.data.length; i++) {
        expand.push(responseDataJson.data.data[i].name);
      }
      setExpand(expand)
      setResponse(responseDataJson.data.data)
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = responseData.data;
        if(!isEmpty(responseDataJson.data.data)) {
          const customerIds = dynamicParameters.customer_id == 14 || dynamicParameters.customer_id == 13;
         for (let [key, value] of Object.entries(responseDataJson.data.data)) {
          /*below condition is for pidilite delivery details */
          if(value?.status === "Cancelled"){
            continue;
          }
        value.actions =  <div> 
                  {(pageLayoutData[1].title1 !== "Products") && (pageLayoutData[1].title1 !== "Inventory") && (value?.childData?.length > 0) ? <a onClick={(e) => openModalTreeView(e, value)}><i className="fa fa-expand"></i></a> : ''}
                  {(value.add == true || value[`add${pageLayoutData[0].hasOwnProperty('addButtonParentName') && pageLayoutData[0].addButtonParentName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonParentName.replace(/\s+/g, '') : pageLayoutData[0].addButtonParentName
                    }Permission`] === true) && <a onClick={(e) => opneParent(e, value)}><i className="fa fa-plus-square-o fa-add"></i></a>}
                  {(value.edit == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true) && <a onClick={(e) => editOpenModal(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {(value.del == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
                  }Permission`] === true) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value.editExtra == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildExtraName') && pageLayoutData[0].addButtonChildExtraName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildExtraName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildExtraName
                    }Permission`] === true) && <a onClick={(e) => editOpenModalExtra(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {responseDataJson.data.editPermission == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => editComponent(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a> : ''}
                  {responseDataJson.data.deletePermission == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => deleteparent1(e, value)}><i className="fa fa-trash-o fa-delete"></i></a> : ''}
                  {customerIds && pageLayoutData[1].title1 == "Delivery" ? (value.fifo_flag == 1) ? <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> : <i onClick={() => handleRefreshIcon(value.name)} className="fa fa-refresh + refresh-icon"></i>
                    : (value.download == true) && <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> }
                  {(value.restore == true) && <a onClick={(e) => restoreParent(e, value)}><i className="fa fa-recycle"></i></a>}
                  {(value.po_type === 'Reclamation PO') &&
                  <Tippy interactive={false} offset={[20, 10]} delay={50} placement={"top"} theme={'light'} animation='shift-toward' content={<div>
                  <h5 style={{ height: '20px', width: '8rem', fontSize: "15px" }}>{pageLayoutData[0].addButtonChildName}</h5></div>}>
                  <i className="fa fa-info-circle info-icon"></i></Tippy>}
                  {(value.master_delivery === 1 && value.DeleteMasterDeliveryPermission) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value?.tp_download === "1" && value.tp_id) && <i className="fa fa-file-pdf-o refresh-icon" aria-hidden="true" onClick={() => handleTpPdfDownload(value)} />}
        </div>;
           if(value.image){
             value.image = <div>
              <img src={value.image} alt="no img" width="50" height="50" />
              </div>;
            }
        }
      }
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setloadTableData(true);
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }
    }
  }

  const MySearch = (props) => {
    let input;
    const changeInputFunction = (e,input) => {
      if(e.which=== 13 ){
        handleClick();
      }
      if(e.which === 32 && !input.value.length)
      swal({
        title:`${t("alerts.spaces_not_allowed")}`, 
        text:`${t("alerts.search_is_restricted")}`, 
        icon:"warning", 
        button:`${t("alerts.ok")}`
      }) 
    }   
      const clearchangeInputFunction = (e,input) => {
        if(e.which===8 && input.value.length===1){
          clearSearchData(e);
        }
       }
   
    const handleClick = async () => {
      if(input.value == ''){
        swal({
          title:`${t("alerts.enter_search")}`, 
          text:`${t("alerts.value_to_search")}`, 
          icon:"warning", 
          button:`${t("alerts.ok")}`
        }) 
        return false;
      }
      setloadTableData(false);
      props.onSearch(input.value);
      setsearchInputValue(input.value);
      let totalParams;
      let startFrom = 0;
      let searchFormData = {};
      let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
      if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
        const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
        totalParams = {...totalParams, ...extraParameteres}
      } 
      totalParams= {...totalParams, start_from: startFrom, ...dynamicParameters}
      for (let formElementIdentifier in formValues) {
          searchFormData[formElementIdentifier] = formValues[formElementIdentifier].value;
      }
      totalParams = {...totalParams, element:input.value.replace(/^\s+|\s+$/gm,'')}
      let newObj = { ...searchFormData, ...totalParams}
      if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
        let paramsConverted = new URLSearchParams(newObj);
        getURL = (`${getURL}?${paramsConverted.toString()}`);
        let responseData = await FetchAPI(getURL);
        if(responseData.status == 200){
          setError(false);
          let responseDataJson = await responseData.json();
          for (let i = 0; i < responseDataJson.data.data.length; i++) {
            if (responseDataJson?.data?.data[i]?.childData?.length === 0) {
              array.push(responseDataJson.data.data[i].name);
            }
          }
          setArray(array)
          if(!isEmpty(responseDataJson.data.data)) {
             for (let [key, value] of Object.entries(responseDataJson.data.data)) {
              value.actions =  <div> 
                  {(pageLayoutData[1].title1 !== "Products") && (pageLayoutData[1].title1 !== "Inventory") && (value?.childData?.length > 0) ? <a onClick={(e) => openModalTreeView(e, value)}><i className="fa fa-expand"></i></a> : ''}
                  {(value.add == true || value[`add${pageLayoutData[0].hasOwnProperty('addButtonParentName') && pageLayoutData[0].addButtonParentName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonParentName.replace(/\s+/g, '') : pageLayoutData[0].addButtonParentName
                    }Permission`] === true) && <a onClick={(e) => opneParent(e, value)}><i className="fa fa-plus-square-o fa-add"></i></a>}
                  {(value.edit == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true) && <a onClick={(e) => editOpenModal(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {(value.del == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
                  }Permission`] === true) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value.editExtra == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildExtraName') && pageLayoutData[0].addButtonChildExtraName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildExtraName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildExtraName
                    }Permission`] === true) && <a onClick={(e) => editOpenModalExtra(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {responseDataJson.data.editPermission == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => editComponent(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a> : ''}
                  {responseDataJson.data.deletePermission == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => deleteparent1(e, value)}><i className="fa fa-trash-o fa-delete"></i></a> : ''}
                  {dynamicParameters.customer_id == 14 && pageLayoutData[1].title1 == "Delivery" ? (value.fifo_flag == 1) ? <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> : <i onClick={() => handleRefreshIcon(value.name)} className="fa fa-refresh + refresh-icon"></i>
                    : (value.download == true) && <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> }
                  {(value.restore == true) && <a onClick={(e) => restoreParent(e, value)}><i className="fa fa-recycle"></i></a>}
                  {(value.po_type === 'Reclamation PO') &&
                  <Tippy interactive={false} offset={[20, 10]} delay={50} placement={"top"} theme={'light'} animation='shift-toward' content={<div>
                  <h5 style={{ height: '20px', width: '8rem', fontSize: "15px" }}>{pageLayoutData[0].addButtonChildName}</h5></div>}>
                  <i className="fa fa-info-circle info-icon"></i></Tippy>}
                  {(value.master_delivery === 1 && value.DeleteMasterDeliveryPermission) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value?.tp_download === "1" && value.tp_id) && <i className="fa fa-file-pdf-o refresh-icon" aria-hidden="true" onClick={() => handleTpPdfDownload(value)} />}
              </div>;
                 if(value.image){
                   value.image = <div>
                    <img src={value.image} alt="no img" width="50" height="50" />
                    </div>;
                  }
            }
          }
          setpage(1);
          setSelectedValue(1);
          setColumns(responseDataJson.data.columns);
          getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
          setproductsData(responseDataJson.data.data);
          setformValues(pageLayoutData[0].formValues);
          settotalrecords(responseDataJson.data.recordsTotal);
          setshowCSearch(true);
          setloadTableData(true);
          setSelectOption(
            Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
          ); 
        }
        else {
          setloadTableData(false);
          setError(true);
          setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
        }  
      }
      else {
        let responseData = await PostAPI(getURL, newObj);
        let responseDataJson = responseData.data;
        for (let i = 0; i < responseDataJson.data.data.length; i++) {
          expand.push(responseDataJson.data.data[i].name);
          }
        setExpand(expand)
        setResponse(responseDataJson.data.data)
        if(responseData.status == 200){
          setError(false);
          let responseDataJson = responseData.data;
          if(!isEmpty(responseDataJson.data.data)) {
            for (let [key, value] of Object.entries(responseDataJson.data.data)) {
              value.actions =  <div> 
                  {(pageLayoutData[1].title1 !== "Products") && (pageLayoutData[1].title1 !== "Inventory") && (value?.childData?.length > 0) ? <a onClick={(e) => openModalTreeView(e, value)}><i className="fa fa-expand"></i></a> : ''}
                  {(value.add == true || value[`add${pageLayoutData[0].hasOwnProperty('addButtonParentName') && pageLayoutData[0].addButtonParentName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonParentName.replace(/\s+/g, '') : pageLayoutData[0].addButtonParentName
                    }Permission`] === true) && <a onClick={(e) => opneParent(e, value)}><i className="fa fa-plus-square-o fa-add"></i></a>}
                  {(value.edit == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true) && <a onClick={(e) => editOpenModal(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {(value.del == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
                  }Permission`] === true) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value.editExtra == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildExtraName') && pageLayoutData[0].addButtonChildExtraName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildExtraName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildExtraName
                    }Permission`] === true) && <a onClick={(e) => editOpenModalExtra(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {responseDataJson.data.editPermission == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => editComponent(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a> : ''}
                  {responseDataJson.data.deletePermission == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => deleteparent1(e, value)}><i className="fa fa-trash-o fa-delete"></i></a> : ''}
                  {dynamicParameters.customer_id == 14 && pageLayoutData[1].title1 == "Delivery" ? (value.fifo_flag == 1) ? <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> : <i onClick={() => handleRefreshIcon(value.name)} className="fa fa-refresh + refresh-icon"></i>
                    : (value.download == true) && <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> }
                  {(value.restore == true) && <a onClick={(e) => restoreParent(e, value)}><i className="fa fa-recycle"></i></a>}
                  {(value.po_type === 'Reclamation PO') &&
                  <Tippy interactive={false} offset={[20, 10]} delay={50} placement={"top"} theme={'light'} animation='shift-toward' content={<div>
                  <h5 style={{ height: '20px', width: '8rem', fontSize: "15px" }}>{pageLayoutData[0].addButtonChildName}</h5></div>}>
                  <i className="fa fa-info-circle info-icon"></i></Tippy>}
                  {(value.master_delivery === 1 && value.DeleteMasterDeliveryPermission) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value?.tp_download === "1" && value.tp_id) && <i className="fa fa-file-pdf-o refresh-icon" aria-hidden="true" onClick={() => handleTpPdfDownload(value)} />}
              </div>;
                 if(value.image){
                   value.image = <div>
                    <img src={value.image} alt="no img" width="50" height="50" />
                    </div>;
                  }
            }
          }
          setpage(1);
          setColumns(responseDataJson.data.columns);
          getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
          setproductsData(responseDataJson.data.data);
          setformValues(pageLayoutData[0].formValues);
          settotalrecords(responseDataJson.data.recordsTotal);
          setshowCSearch(true);
          setloadTableData(true);
        }
        else {
          setloadTableData(false);
          setError(true);
          setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
        }
      }
    }
    async function clearSearchData(event) {
      setloadTableData(false);
      event.preventDefault();
      let totalParams;
      let startFrom= 0;
      let cpage;
      let searchFormData={};
      let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
      if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
        const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
        totalParams = {...totalParams, ...extraParameteres}
      }     
        totalParams = {...totalParams, start_from: startFrom}
      for (let formElementIdentifier in values) {
          searchFormData[formElementIdentifier] = values[formElementIdentifier].value;
      }
      totalParams = {...totalParams, ...dynamicParameters, ...searchFormData}
      if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
        let paramsConverted = new URLSearchParams(totalParams);
        getURL = (`${getURL}?${paramsConverted.toString()}`);
        setsearchInputValue();
        let responseData = await FetchAPI(getURL);
        if(responseData.status == 200){
          setError(false);
          let responseDataJson = await responseData.json();
          for (let i = 0; i < responseDataJson.data.data.length; i++) {
            if (responseDataJson?.data?.data[i]?.childData?.length === 0) {
              array.push(responseDataJson.data.data[i].name);
            }
          }
          setArray(array)
          if(!isEmpty(responseDataJson.data.data)) {
              for (let [key, value] of Object.entries(responseDataJson.data.data)) {
                value.actions =  <div> 
                  {(pageLayoutData[1].title1 !== "Products") && (pageLayoutData[1].title1 !== "Inventory") && (value?.childData?.length > 0) ? <a onClick={(e) => openModalTreeView(e, value)}><i className="fa fa-expand"></i></a> : ''}
                  {(value.add == true || value[`add${pageLayoutData[0].hasOwnProperty('addButtonParentName') && pageLayoutData[0].addButtonParentName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonParentName.replace(/\s+/g, '') : pageLayoutData[0].addButtonParentName
                    }Permission`] === true) && <a onClick={(e) => opneParent(e, value)}><i className="fa fa-plus-square-o fa-add"></i></a>}
                  {(value.edit == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true) && <a onClick={(e) => editOpenModal(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {(value.del == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
                  }Permission`] === true) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value.editExtra == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildExtraName') && pageLayoutData[0].addButtonChildExtraName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildExtraName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildExtraName
                    }Permission`] === true) && <a onClick={(e) => editOpenModalExtra(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {responseDataJson.data.editPermission == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => editComponent(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a> : ''}
                  {responseDataJson.data.deletePermission == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => deleteparent1(e, value)}><i className="fa fa-trash-o fa-delete"></i></a> : ''}
                  {dynamicParameters.customer_id == 14 && pageLayoutData[1].title1 == "Delivery" ? (value.fifo_flag == 1) ? <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> : <i onClick={() => handleRefreshIcon(value.name)} className="fa fa-refresh + refresh-icon"></i>
                    : (value.download == true) && <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> }
                  {(value.restore == true) && <a onClick={(e) => restoreParent(e, value)}><i className="fa fa-recycle"></i></a>}
                  {(value.po_type === 'Reclamation PO') &&
                  <Tippy interactive={false} offset={[20, 10]} delay={50} placement={"top"} theme={'light'} animation='shift-toward' content={<div>
                  <h5 style={{ height: '20px', width: '8rem', fontSize: "15px" }}>{pageLayoutData[0].addButtonChildName}</h5></div>}>
                  <i className="fa fa-info-circle info-icon"></i></Tippy>}
                  {(value.master_delivery === 1 && value.DeleteMasterDeliveryPermission) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value?.tp_download === "1" && value.tp_id) && <i className="fa fa-file-pdf-o refresh-icon" aria-hidden="true" onClick={() => handleTpPdfDownload(value)} />}
              </div>;
                   if(value.image){
                     value.image = <div>
                      <img src={value.image} alt="no img" width="50" height="50" />
                      </div>;
                    }
              }
          }
          setpage(1);
          setSelectedValue(1);
          setColumns(responseDataJson.data.columns);
          getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
          setproductsData(responseDataJson.data.data);
          setformValues(pageLayoutData[0].formValues);
          settotalrecords(responseDataJson.data.recordsTotal);
          setsearchInputValue();
          setshowCSearch(false);
          setloadTableData(true);
          setSelectOption(
            Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
          );
        }
        else {
          setloadTableData(false);
          setError(true);
          setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
        }  
      }
      else {
       setsearchInputValue();
      let responseData = await PostAPI(getURL, totalParams);
        if(responseData.status == 200){
          setError(false);
          let responseDataJson = responseData.data;
          for (let i = 0; i < responseDataJson.data.data.length; i++) {
            expand.push(responseDataJson.data.data[i].name);
          }
          setExpand(expand)
          setResponse(responseDataJson.data.data)
          if(!isEmpty(responseDataJson.data.data)) {
             for (let [key, value] of Object.entries(responseDataJson.data.data)) {
              value.actions =  <div> 
                  {(pageLayoutData[1].title1 !== "Products") && (pageLayoutData[1].title1 !== "Inventory") && (value?.childData?.length > 0) ? <a onClick={(e) => openModalTreeView(e, value)}><i className="fa fa-expand"></i></a> : ''}
                  {(value.add == true || value[`add${pageLayoutData[0].hasOwnProperty('addButtonParentName') && pageLayoutData[0].addButtonParentName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonParentName.replace(/\s+/g, '') : pageLayoutData[0].addButtonParentName
                    }Permission`] === true) && <a onClick={(e) => opneParent(e, value)}><i className="fa fa-plus-square-o fa-add"></i></a>}
                  {(value.edit == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true) && <a onClick={(e) => editOpenModal(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {(value.del == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
                  }Permission`] === true) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value.editExtra == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildExtraName') && pageLayoutData[0].addButtonChildExtraName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildExtraName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildExtraName
                    }Permission`] === true) && <a onClick={(e) => editOpenModalExtra(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {responseDataJson.data.editPermission == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => editComponent(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a> : ''}
                  {responseDataJson.data.deletePermission == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => deleteparent1(e, value)}><i className="fa fa-trash-o fa-delete"></i></a> : ''}
                  {dynamicParameters.customer_id == 14 && pageLayoutData[1].title1 == "Delivery" ? (value.fifo_flag == 1) ? <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> : <i onClick={() => handleRefreshIcon(value.name)} className="fa fa-refresh + refresh-icon"></i>
                    : (value.download == true) && <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> }
                  {(value.restore == true) && <a onClick={(e) => restoreParent(e, value)}><i className="fa fa-recycle"></i></a>}
                  {(value.po_type === 'Reclamation PO') &&
                  <Tippy interactive={false} offset={[20, 10]} delay={50} placement={"top"} theme={'light'} animation='shift-toward' content={<div>
                  <h5 style={{ height: '20px', width: '8rem', fontSize: "15px" }}>{pageLayoutData[0].addButtonChildName}</h5></div>}>
                  <i className="fa fa-info-circle info-icon"></i></Tippy>}
                  {(value.master_delivery === 1 && value.DeleteMasterDeliveryPermission) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value?.tp_download === "1" && value.tp_id) && <i className="fa fa-file-pdf-o refresh-icon" aria-hidden="true" onClick={() => handleTpPdfDownload(value)} />}
              </div>;
                 if(value.image){
                   value.image = <div>
                    <img src={value.image} alt="no img" width="50" height="50" />
                    </div>;
                  }
            }
          }
          setpage(1);
          setColumns(responseDataJson.data.columns);
          getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
          setproductsData(responseDataJson.data.data);
          setformValues(pageLayoutData[0].formValues);
          settotalrecords(responseDataJson.data.recordsTotal);
          setsearchInputValue();
          setshowCSearch(false);
          setloadTableData(true);
        }
        else {
          setloadTableData(false);
          setError(true);
          setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
        }
      }
    };
    return (
      <div>
        <MDBCol md="4" className="mb-4">
          <input
            className="form-control"
            onKeyPress={(e) => changeInputFunction(e,input)}
            onKeyDown={(e) => clearchangeInputFunction(e,input)}
            style={{ backgroundColor: 'white' }}
            placeholder={`${t("search")}`}
            ref={n => input = n}
            type="text"
            defaultValue={searchInputValue}
          />
        </MDBCol>
        <MDBCol md="2" className="mb-2">
          {(showCSearch == false) && <ButtonField color="info" key="ModalCLRBTN" submit={ handleClick } BName={`${t("search")}`} /> } 
          {(showCSearch == true) && <ButtonField color="info" key="ModalCLRBTN" submit={ (e) => clearSearchData(e) } BName={`${t("clear")}`} />} 
        </MDBCol>
        <MDBCol md="1" className="mb-1"></MDBCol>
      </div>
    );
  };
  const open = () => {
      setmodalType(`${t('add')}`);
      setModalTitle(pageLayoutData[0].addButtonName);
      setModalformValues(pageLayoutData[0].addButtonItems.formValues)
      setSaveUrl(pageLayoutData[0].addButtonItems.saveEndPoint)
      i18n.language === "chi" ? setCommonTitle(pageLayoutData[0].addButtonNameEn) : setCommonTitle(pageLayoutData[0].addButtonName)
      setModalWidth(pageLayoutData[0].addButtonItems.className);
      setDropDownApi(pageLayoutData[0].addButtonItems.hasOwnProperty('dropdownApiEndPoint') ?
      pageLayoutData[0].addButtonItems.dropdownApiEndPoint+'?customer_id='+ cookies.get('customer_id')+'&user_id='+ cookies.get('user_id')+'&language='+language: 'not found');
      setuniqueid();
      setshowModal(true);
      (pageLayoutData[0].addButtonItems.hasOwnProperty('Table') ? 
        setTable(pageLayoutData[0].addButtonItems.Table) : 
        setTable(false));
      (pageLayoutData[0].addButtonItems.hasOwnProperty('headers') ? 
          setHeaders(pageLayoutData[0].addButtonItems.headers) : 
          setHeaders(null));
  }
  const open1 = () => {
    setmodalType(`${t('add')}`);
    setModalTitle(pageLayoutData[0].addButton1Name);
    setModalformValues(pageLayoutData[0].addButton1Items.formValues)
    setSaveUrl(pageLayoutData[0].addButton1Items.apiEndPointAttribute)
    setModalWidth(pageLayoutData[0].addButton1Items.className);
    setDropDownApi(pageLayoutData[1].subComponentsItems.getAttributeDropdowns+'?customer_id='+ cookies.get('customer_id')+'&user_id='+ cookies.get('user_id'));
    setuniqueid();
    setshowModal(true);
  }

  const openChild = () => {
     setextraId();
    setuniqueid();
    setmodalType(`${t('add')}`);
    setModalWidth(pageLayoutData[0].addButtonChildItems.className);
    setModalTitle(pageLayoutData[0].addButtonChildName);
    setModalformValues(pageLayoutData[0].addButtonChildItems.formValues)
    setSaveUrl(pageLayoutData[0].addButtonChildItems.childEndPoint)
    setDropDownApi(pageLayoutData[0].addButtonChildItems.hasOwnProperty('dropdownApiEndPoint') ?
    pageLayoutData[0].addButtonChildItems.dropdownApiEndPoint+'?customer_id='+ cookies.get('customer_id')+'&user_id='+ cookies.get('user_id')+'&language='+language: 'not found');
    setshowModal(true);
    if(pageLayoutData[0].addButtonChildName === 'Reclamation Delivery'){
      (pageLayoutData[0].addButtonChildItems.hasOwnProperty('Table') ? 
      setTable(pageLayoutData[0].addButtonChildItems.Table) : 
      setTable(false));
      (pageLayoutData[0].addButtonChildItems.hasOwnProperty('headers') ? 
        setHeaders(pageLayoutData[0].addButtonChildItems.headers) : 
        setHeaders(null));
      }
  }

  const openComponent = async(event, value) => {
    setIsLoader(true);
    setModalformValues(pageLayoutData[0].addButtonItems)
    let editURL = '';
      editURL = pageLayoutData[1].subComponentsItems.getApiEndPoint+
      '?customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id')+'&language='+language;
    const productDetailsJson = await getWizardDataService(editURL);
    setIsLoader(false);
    setWizardData({
      productsDetail: productDetailsJson
    })
    setmodalType(`${t('edit')}`);
    setmodalgetURL(editURL)

    setRenderComponent(true);
    setShowParentContent(false);
  }
  const openComponent1 = async() => {
    setIsLoader(true)
    setmodalType(`${t('add')}`);
    setModalformValues(pageLayoutData[0].addButton3Items)
    setRenderComponent(true);
    setDropDownApi(pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id')+'&user_id='+ cookies.get('user_id')+'&language='+language);  
    const productViewEndpoint = pageLayoutData[1].subComponentsItems.hasOwnProperty('dropdownApiEndPoint') ? pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id')+'&language='+language  : 'not found'
    const productsViewJson = await getWizardDataService(productViewEndpoint)
    setIsLoader(false)
    setWizardData({
      productsView: productsViewJson,
    })   
    setShowParentContent(!showParentContent);
  } 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
  const opneParent = (event, data) => {
    setVal1(data.hierarchy_name)
    setVal2();
    setWareId(data.ware_id)
    setmodalType(`${t('add')}`);
    setModalTitle(pageLayoutData[0].addButtonParentName);
    i18n.language === "chi" ? setCommonTitle(pageLayoutData[0].addButtonParentNameEn) : setCommonTitle(pageLayoutData[0].addButtonParentName)
    setModalWidth(pageLayoutData[0].addButtonParentItems.className);
    setModalformValues(pageLayoutData[0].addButtonParentItems.formValues);
    setSaveUrl(pageLayoutData[0].addButtonParentItems.addParentEndPoint);
    setuniqueid(data.name);
    setextraId();
      if (data.po_type === "Reclamation PO") {
        const materialAgainstLocationApi = pageLayoutData[0].addButtonChildItems.formValues['from_location'].update.endPoint
        setDropDownApi(materialAgainstLocationApi+
          `?customer_id=`+ cookies.get('customer_id')+`&user_id=`+ cookies.get('user_id')+'&location_id='+ cookies.get('userLocation_id') +'&po_number='+ data.delivery_id);
      }else{
        setDropDownApi(pageLayoutData[0].addButtonParentItems.dropdownApiEndPoint+
          '?customer_id='+ cookies.get('customer_id')+'&user_id='+ cookies.get('user_id') +'&po_number='+ data.delivery_id);
      }  
    setshowModal(true);
  }

  const addChild = (event, data) => {
    let c =
    /* To Render vaue Dynamically in Location Types Feature in Company Module*/
    // data.node.module_id ? setVal1(data.node.module_id)
    // : data.node.l_location_type_id ? setVal1(data.node.l_location_type_id)
    // : setVal1(data.node.c_parent_id)
    // data.node.module_id ? setVal1(data.node.module_id) : setVal1(data.node.l_location_type_id)
    /* To Render vaue Dynamically in Location Types Feature in Company Module*/
    setVal1(data.node.hierarchy_name)
    setVal2(data.node.name)
    setuniqueid(data.node.name);
    setWareId(data.node.ware_id)
    setextraId();
    setmodalType(`${t('add')}`);
    setModalTitle(pageLayoutData[0].addButtonParentName);
    setModalWidth(pageLayoutData[0].addButtonParentItems.className);
    setModalformValues(pageLayoutData[0].addButtonParentItems.formValues);
    setSaveUrl(pageLayoutData[0].addButtonParentItems.addParentEndPoint);
      setDropDownApi(pageLayoutData[0].addButtonParentItems.dropdownApiEndPoint+'?customer_id='+ cookies.get('customer_id')+'&user_id='+ cookies.get('user_id')+'&language='+language);
    setshowModal(true);
  }

  const restoreParent = (event, data) => {
    const restoreURL = pageLayoutData[0].addButtonChildItems.restoreChildEndPoint+'?id='+data.name+'&language='+language;
    swal({
      title:`${t("alerts.sure")}`,
      text:`${t("alerts.restored_data")}`,
      icon:"warning",
      buttons: [`${t('alerts.cancel')}`,`${t('alerts.ok')}`],
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        delelteData(restoreURL);
        swal(`${t('alerts.data_restored')}`, {
          icon: "success",
          timer: 2000,
          button: false
        });
        setTimeout(() => {
          getLatestTableData();
        }, 1000);
      } else {
        swal(`${t('alerts.restored_failed')}`, {
          timer: 2000,
          button: false
        });
      }
    });
  }

  const restoreChild = (event, data) => {
    const restoreURL = pageLayoutData[0].addButtonParentItems.restoreParentEndPoint+'?id='+data.node.name+'&language='+language;
    
 swal({
        title:`${t("alerts.sure")}`,
        text:`${t("alerts.restored_data")}`,
        icon:"warning",
        buttons: [`${t('alerts.cancel')}`,`${t('alerts.ok')}`],
        dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        delelteData(restoreURL);
        swal(`${t('alerts.data_restored')}`, {
          icon: "success",
          timer: 2000,
          button: false
        });
        setTimeout(() => {
          getLatestTableData();
        }, 1000);
      } else {
        swal(`${t('alerts.restored_failed')}`, {
          timer: 2000,
          button: false
        });
      }
    });
  }
  const searchableChild = (event, data) => {
    const flag = (data.node.search == false) ? 1 : 0;
    const customTitle = (flag == 1) ? `${t('alerts.searchable')}` :
    `${t('alerts.unsearchable')}`;

    const searchableURL = pageLayoutData[0].addButtonParentItems.searchParentEndPoint+
    '?id='+data.node.name+'&extra_id='+event.name+'&flag='+flag;
    swal({
      title: customTitle,
      text: `${t('alerts.beware_of_doing')}`,
      icon: "warning",
      buttons: [`${t('alerts.cancel')}`,`${t('alerts.ok')}`],
    })
    .then((willDelete) => {
      if (willDelete) {
        delelteData(searchableURL);
        swal(`${t('alerts.update_successfully')}`, {
          icon: "success",
          timer: 2000,
          button: false
        });
        setTimeout(() => {
          getLatestTableData();
        }, 1000);
      } else {
        swal(`${t('alerts.data_safe')}`, {
          timer: 2000,
          button: false
        });
      }
    });
  }

  const deleteParent = (event, id) => {
    setshowExpandColumn(false)
    let delURL;
    let URL;
    if(cookies.get("customer_id") === "15" && pageLayoutData[1].title1 === "Delivery"){
      URL = pageLayoutData[1].subComponentsItems.deleteMasterDelivery;
    }else{
      URL = (pageLayoutData[0].addButtonChildItems) ? pageLayoutData[0].addButtonChildItems.deleteChildEndPoint : pageLayoutData[0].addButtonItems.deleteChildEndPoint
    }
    delURL = URL +'?id='+id.name+ '&customer_id='+ cookies.get('customer_id')+'&user_id='+ cookies.get('user_id')+'&language='+language
    swal({
      title:`${t("alerts.sure")}`,
      text:`${t("alerts.deleted_not_recovered")}`,
      icon:"warning",
      buttons: [`${t('alerts.cancel')}`,`${t('alerts.ok')}`],
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        delelteData(delURL);
        swal(`${t('alerts.data_deleted')}`, {
          icon: "success",
          timer: 2000,
          button: false
        });
        setTimeout(() => {
          getLatestTableData();
        }, 1000);
      } else {
        swal(`${t('alerts.data_safe')}`, {
          timer: 2000,
          button: false
        });
      }
    });
  }

  const deleteParentPassword = (event, id) => {
    let delURL = pageLayoutData[0].deletePwdButtonItems.deleteParentEndPoint + '?id=' + id.node.name + '&extra_id=' + event.name + '&language=' + language;
    switch (id.node.is_mapped) {
      case 1:
        swal({
          title: id.node.alert,
          text: "Do you want to un-map and delete?",
          icon: "info",
          buttons: [`${t('alerts.cancel')}`,
          `${t('alerts.ok')}`],
          dangerMode: true,
        })
          .then((willDelete) => {
            if (willDelete) {
              setmodalType(`${t('enter')}`);
              setuniqueid(id.node.name);
              setModalTitle('Password');
              setModalformValues(pageLayoutData[0].deletePwdButtonItems.formValues);
              setSaveUrl(delURL);
              setModalWidth('modal-50w');
              setshowModal(true);
            } else {
              swal(t("Your data is safe!"), {
                timer: 2000,
                button: false
              });
            }
          });
        break
      default:
        (async function del1() {
          swal({
            title: `${t("alerts.sure")}`,
            text: `${t("alerts.deleted_not_recovered")}`,
            icon: "warning",
            buttons: [`${t('alerts.cancel')}`,
            `${t('alerts.ok')}`],
            dangerMode: true,
          })
            .then((willDelete) => {
              if (willDelete) {
                setmodalType(`${t('enter')}`);
                setuniqueid(id.node.name);
                setModalTitle('Password');
                setModalformValues(pageLayoutData[0].deletePwdButtonItems.formValues);
                setSaveUrl(delURL);
                setModalWidth('modal-50w');
                setshowModal(true);
              } else {
                swal(t("Your data is safe!"), {
                  timer: 2000,
                  button: false
                });
              }
            });
        })()
    }
  }

  const deleteChildPassword = (event, id) => {
    let delURL = pageLayoutData[0].deletePwdButtonItems.deleteEndPoint + '?id=' + id.node.name + '&customer_id=' + cookies.get('customer_id') + '&user_id=' + cookies.get('user_id') + '&language=' + language;
    switch (id.node.is_mapped) {
      case 1:
        swal({
          title: id.node.alert,
          text: "Do you want to un-map and delete?",
          icon: "info",
          buttons: [`${t('alerts.cancel')}`,
          `${t('alerts.ok')}`],
          dangerMode: true,
        })
          .then((willDelete) => {
            if (willDelete) {
              setmodalType(`${t('enter')}`);
              setuniqueid(id.node.name);
              setModalTitle('Password');
              setModalformValues(pageLayoutData[0].deletePwdButtonItems.formValues);
              setSaveUrl(delURL);
              setModalWidth('modal-50w');
              setshowModal(true);
            } else {
              swal(t("Your data is safe!"), {
                timer: 2000,
                button: false
              });
            }
          });
        break;
      default:
        (async function del1() {
          swal({
            title: t("Are you sure?"),
            text: t("Once deleted, you will not be able to recover this data!"),
            icon: t("warning"),
            buttons: [`${t('alerts.cancel')}`,
            `${t('alerts.ok')}`],
            dangerMode: true,
          })
            .then((willDelete) => {
              if (willDelete) {
                setmodalType(`${t('enter')}`);
                setuniqueid(id.node.name);
                setModalTitle('Password');
                setModalformValues(pageLayoutData[0].deletePwdButtonItems.formValues);
                setSaveUrl(delURL);
                setModalWidth('modal-50w');
                setshowModal(true);
              } else {
                swal(t("Your data is safe!"), {
                  timer: 2000,
                  button: false
                });
              }
            });
        })();
    }
  }

  const openModalTreeView = (event, data) => {
    setmodalType(`${t('view')}`);
    setModalTitle( pageLayoutData[1].title1);
    setmodalgetURL(pageLayoutData[0].treeEndPoint+'?id='+data.name+'&customer_id='+ cookies.get('customer_id')+'&language='+language);
    setShowModald3(true);
  }
  const openLocation = () => {
    setModalTitle(pageLayoutData[0].addButtonName4);
    setModalWidth(pageLayoutData[0].addButton4Items.className);
    setModalformValues(pageLayoutData[0].addButton4Items.formValues)
    setSaveUrl(pageLayoutData[0].addButton4Items.apiEndPointLocation)
    setmodalType(`${t('add')}`);
    setDropDownApi(pageLayoutData[1].subComponentsItems.getLocationDropdowns + '?customer_id='+ cookies.get('customer_id')+'&user_id='+cookies.get('user_id')+'&language='+language); 
    setshowModal(true);
  }
  const openBusinessUnit = () => {
    setmodalType(`${t('add')}`);
    setModalTitle(pageLayoutData[0].addButtonName2);
    setModalWidth(pageLayoutData[0].addButtonItems2.className);
    setModalformValues(pageLayoutData[0].addButtonItems2.formValues)
    setSaveUrl(pageLayoutData[0].addButtonItems2.apiEndPointBussinessUnit)
    setDropDownApi(pageLayoutData[1].subComponentsItems.hasOwnProperty('getBusinessDropdowns') ? dropDownApi : 'not found')
    setshowModal(true);
  }
  

  const opneEditParent = (row,rowInfo) => {
    let isReclamationTitle =  row.po_type === "Reclamation PO"
    setLine(rowInfo.node.line)
    setVal1(rowInfo.node.hierarchy_name)
    setVal2(rowInfo.node.parentid)
    setmodalType(`${t('edit')}`);
    i18n.language === "chi" ? setCommonTitle(pageLayoutData[0].addButtonParentNameEn) : isReclamationTitle ? setCommonTitle(pageLayoutData[0].addButtonChildName) : setCommonTitle(pageLayoutData[0].addButtonParentName)
    setModalWidth(pageLayoutData[0].addButtonParentItems.className);

    let title1 = i18n.language == "chi" ? pageLayoutData[1].title1En : pageLayoutData[1].title1
    let title2 = i18n.language == "chi" ? pageLayoutData[1].title2En : pageLayoutData[1].title2
     isReclamationTitle ? setModalTitle(pageLayoutData[0].addButtonChildName) : setModalTitle(pageLayoutData[0].addButtonParentName);
  
    (pageLayoutData[0].editButtonParentItems !== undefined ? 
    setModalformValues(pageLayoutData[0].editButtonParentItems.formValues) : 
    setModalformValues(pageLayoutData[0].addButtonParentItems.formValues));

    setSaveUrl(pageLayoutData[0].addButtonParentItems.addParentEndPoint);
    setuniqueid(rowInfo.node.name);
    setextraId(row.name);
    setmodalgetURL(pageLayoutData[0].editButtonParentItems.getParentEndPoint+'?customer_id='+ cookies.get('customer_id')+'&user_id='+ cookies.get('user_id')
    +'&id='+ rowInfo.node.name+'&extra_id='+ row.name + '&delivery_id=' + row.delivery_id+'&language='+language);
    setDropDownApi(pageLayoutData[0].editButtonParentItems.dropdownApiEndPoint+'?customer_id='+ cookies.get('customer_id')+'&user_id='+ cookies.get('user_id')+'&language='+language); 
    setshowModal(true);
  }

  const close = () => {
    setshowModal(false);
    setShowModald3(false);
  }

  const editOpenModal = (event, id) => {
    i18n.language === "chi" ? setCommonTitle(pageLayoutData[0].addButtonChildNameEn) : setCommonTitle(pageLayoutData[0].addButtonChildName)
    setmodalType(`${t('edit')}`);
    setModalWidth(pageLayoutData[0].editButtonChildItems.className);
    setModalTitle(pageLayoutData[0].addButtonChildName);
    (pageLayoutData[0].editButtonChildItems.formValues !== undefined ? 
      setModalformValues(pageLayoutData[0].editButtonChildItems.formValues) :
       setModalformValues(pageLayoutData[0].addButtonChildItems.formValues));
    setuniqueid(id.name)
    setmodalgetURL(pageLayoutData[0].addButtonChildItems.getChildEndPoint+'?id='+id.name+'&language='+language);
    setSaveUrl(pageLayoutData[0].addButtonChildItems.childEndPoint);
    setDropDownApi(pageLayoutData[0].addButtonChildItems.hasOwnProperty('dropdownApiEndPoint') ? 
    pageLayoutData[0].addButtonChildItems.dropdownApiEndPoint+'?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id')+'&language='+language: 'not found');
    setshowModal(true);
  }
 

  const editOpenModalExtra = (event, id) => {
    setmodalType(`${t('edit')}`);
    setModalTitle(pageLayoutData[0].addButtonChildExtraName);
    cookies.get("customer_id") === '12' ? setTitle1(`${t('map')}`) : setTitle1('')
    i18n.language === "chi" ? setCommonTitle(pageLayoutData[0].addButtonChildExtraNameEn) : setCommonTitle(pageLayoutData[0].addButtonChildExtraName)
    setModalformValues(pageLayoutData[0].editButtonChildExtraItems.formValues);
    setuniqueid(id.name)
    setmodalgetURL(pageLayoutData[0].editButtonChildExtraItems.getChildEndPoint+'?id='+id.name+'&language='+language);
    setSaveUrl(pageLayoutData[0].editButtonChildExtraItems.childEndPoint);
    setDropDownApi(pageLayoutData[0].editButtonChildExtraItems.hasOwnProperty('dropdownApiEndPoint') ? 
    pageLayoutData[0].editButtonChildExtraItems.dropdownApiEndPoint+'?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id')+'&language='+language: 'not found');
    pageLayoutData[0].editButtonChildExtraItems.hasOwnProperty('Table') ? 
      setTable(pageLayoutData[0].editButtonChildExtraItems.Table) : 
      setTable(false);
    pageLayoutData[0].editButtonChildExtraItems.hasOwnProperty('editHeaders') ? 
        setHeaders(pageLayoutData[0].editButtonChildExtraItems.editHeaders) : 
        setHeaders(null);
    setshowModal(true);
  }
  const editComponent = async(event, value) => {
    setIsLoader(true);
    (pageLayoutData[0].editButtonItems !== undefined ? 
      setModalformValues(pageLayoutData[0].editButtonItems) : 
      setModalformValues(pageLayoutData[0].addButtonItems.formValues));
   setshowExpandColumn(false)
    let editURL = '';
      editURL = pageLayoutData[1].subComponentsItems.getApiEndPoint+ 
      '?id=' +value.id+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id')+'&language='+language;
      setDropDownApi(pageLayoutData[1].subComponentsItems.hasOwnProperty('dropdownApiEndPoint') ? pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id')+'&language='+language  : 'not found' );
    const productViewEndpoint = pageLayoutData[1].subComponentsItems.hasOwnProperty('dropdownApiEndPoint') ? pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id')+'&language='+language   : 'not found';
    const productsViewJson = await getWizardDataService(productViewEndpoint);
    const productDetailsJson = await getWizardDataService(editURL);
    setIsLoader(false);

    setWizardData({
      productsView: productsViewJson,
      productsDetail: productDetailsJson,
    })
    setmodalType(`${t('edit')}`);
    setmodalgetURL(editURL)
    setuniqueId(value.id);
    (value.image) ? setImagePath(value.image) : setImagePath()
    setRenderComponent(true);
    setShowParentContent(false);
  }
  async function filteredExport(data) {
    let arr = Object.values(data);
    let valueNull = arr.some((el) => el.value !== null)
    let data1 = data['location_type']
    let searchFormData = {};
    let title1 = i18n.language == "chi" ? pageLayoutData[1].title1En : pageLayoutData[1].title1
    let totalParams;
    let getURL = pageLayoutData[0].exportApiEndPoint;
    let requiredValues = {
      user_id:cookies.get('user_id'),
      customer_id:cookies.get('customer_id'),
      email:localStorage.getItem('email'),
      userLocation_id:cookies.get('userLocation_id'),
      userRole_name:cookies.get('userRole_name'),
      language:language
    }
    totalParams = {...totalParams, ...requiredValues}
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null && title1 !== 'Location'){
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    for (let formElementIdentifier in data) {
      if(data[formElementIdentifier].elementType === 'multiselect') {
        if((data[formElementIdentifier].value)) {
          let arrayConvert = [];
          data[formElementIdentifier].value.map(function(fValue, indexId){
            arrayConvert[indexId] = fValue.value;
          });
          searchFormData[formElementIdentifier] = arrayConvert;
        }
        else
          searchFormData[formElementIdentifier] = null;
        }
      else if(data[formElementIdentifier].elementType === 'select'){
        searchFormData[formElementIdentifier] = data[formElementIdentifier].value;
      }
    }
    let newObj = { ...searchFormData, ...totalParams}
    let responseData;
    if (pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      if (data['location_type'].value === "" || valueNull === false) {
        return swal({
          title: `${t("alerts.choose_valid_loactionType")}`,
          text: `${t("alerts.please_cannot_be_selected")}`,
          icon: "warning",
          button: `${t("alerts.ok")}`
        })
      } else {
        let paramsConverted = new URLSearchParams(newObj);
        getURL = (`${getURL}?${paramsConverted.toString()}`);
        responseData = await FetchAPI(getURL);
      }
    } else {
      responseData = await PostAPI(getURL, newObj);
    }
    if(responseData.status == 200){
      swal({
        title:`${t("alerts.your_request_under_process")}`, 
        text:`${t("alerts.receive_email")}`, 
        icon:"success", 
        button:`${t("alerts.ok")}`
      })
      }
      else{
        swal({
          title:`${t("alerts.something_went_wrong1")}`, 
          text:`${t("alerts.download_again")}`, icon:"error", 
          button:`${t("alerts.ok")}`})
      }
  }

  async function delelteData(URL) {
    const getresponse = await FetchAPI(URL);
    const getresponseJson = await getresponse.json();
    const responseData = getresponseJson.data;
  }
  const deleteparent1 = (event, value) => {
    setshowExpandColumn(false)
    let uniqueId = '';
    let delURL = '';
      uniqueId = value.id;
      delURL = pageLayoutData[1].subComponentsItems.deleteApiEndPoint + '?id=' +uniqueId+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id')+'&language='+language;
    let msg = '';
    swal({
      title:`${t("alerts.sure")}`, 
      text:`${t("alerts.deleted_not_recovered")}`, 
      icon:"warning",
      buttons: [`${t('alerts.cancel')}`, `${t('alerts.ok')}`], 
     dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        delelteData(delURL);
        swal(`${t('alerts.data_deleted')}`, {
          icon: "success",
          timer: 2000,
          button: false
        });
        setTimeout(() => {
          getLatestTableData();
        }, 1000);
      } else {
        swal(`${t('alerts.data_safe')}`, {
          timer: 2000,
          button: false
        });
      }
    });
  }

  const deleteOpenModal = (event, id) => {
    let delURL;
    delURL = pageLayoutData[0].addButtonParentItems.deleteParentEndPoint+'?id='+id.node.name+'&extra_id='+event.name+'&language='+language;
    swal({
        title:`${t("alerts.sure")}`,
        text:`${t("alerts.deleted_not_recovered")}`,
        icon:"warning",
        buttons: [`${t('alerts.cancel')}`,`${t('alerts.ok')}`],
        dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        delelteData(delURL);
        swal(`${t('alerts.data_deleted')}`, {
          icon: "success",
          timer: 2000,
          button: false
        });
        setTimeout(() => {
          getLatestTableData();
        }, 1000);
      } else {
        swal(`${t('alerts.data_safe')}`, {
          timer: 2000,
          button: false
        });
      }
    });
  }

  useEffect(() => {
    (async () => {
      (pageLayoutData[0].filterStatus == true && setformValues(pageLayoutData[0].formValues));
      if (pageLayoutData != 'undefined') {
        if(pageLayoutData[0].filterStatusDefault === true)
        setshowFilter(true);
        else
        setshowFilter(false);
        setloadTableData(false);
        setUrl(pageLayoutData[0].exportEndPoint)
        setsearchInputValue();
        setshowCSearch(false);
        setpage(1);
        setSelectedValue(1);
        let totalParams;
        let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
        if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
          const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
          totalParams = {...totalParams, ...extraParameteres}
        }        
        if(pageLayoutData[1].subComponentsItems.firstTimeParameters !== null) {
          const firstTimeParameters = pageLayoutData[1].subComponentsItems.firstTimeParameters;
          totalParams = {...totalParams, ...firstTimeParameters}
        }
        totalParams = {...totalParams, ...dynamicParameters}
        if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
          let paramsConverted = new URLSearchParams(totalParams);
          getURL = (`${getURL}?${paramsConverted.toString()}`);
          let responseData = await FetchAPI(getURL);
          if(responseData.status == 200){
            setError(false);
            let responseDataJson = await responseData.json();
            for (let i = 0; i < responseDataJson.data.data.length; i++) {
              if (responseDataJson?.data?.data[i]?.childData?.length === 0) {
                array.push(responseDataJson.data.data[i].name);
              }
            }
            setAddPermission(responseDataJson.data[`add${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName}Permission`])
            setAddPermission1(responseDataJson.data[`assign${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName}Permission`])
            setAddPermission2(responseDataJson.data[`add${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name}Permission`])
            setAddPermission3(responseDataJson.data[`add${pageLayoutData[0].hasOwnProperty('addButtonName4') && pageLayoutData[0].addButtonName4.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName4.replace(/\s+/g, '') : pageLayoutData[0].addButtonName4}Permission`])
            setAddPermission4(responseDataJson.data[`add${pageLayoutData[0].hasOwnProperty('addButtonName2') && pageLayoutData[0].addButtonName2.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName2.replace(/\s+/g, '') : pageLayoutData[0].addButtonName2}Permission`])
            setAddChildPermission(responseDataJson.data[`add${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName}Permission`])
            setimportPermission(responseDataJson.data[`import${pageLayoutData[0].hasOwnProperty('importButtonName') && pageLayoutData[0].importButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].importButtonName.replace(/\s+/g, '') : pageLayoutData[0].importButtonName}Permission`])
            setimportPermission1(responseDataJson.data[`import${pageLayoutData[0].hasOwnProperty('importButtonName1') && pageLayoutData[0].importButtonName1.indexOf(' ') >= 0 ? pageLayoutData[0].importButtonName1.replace(/\s+/g, '') : pageLayoutData[0].importButtonName1}Permission`])
            setimportPermission2(responseDataJson.data[`import${pageLayoutData[0].hasOwnProperty('importButtonName2') && pageLayoutData[0].importButtonName2.indexOf(' ') >= 0 ? pageLayoutData[0].importButtonName2.replace(/\s+/g, '') : pageLayoutData[0].importButtonName2}Permission`])
            setexportPermission(responseDataJson.data[`exportPermission`])
            setexportPermission1(responseDataJson.data[`export${pageLayoutData[0].hasOwnProperty('exportButtonName1') && pageLayoutData[0].exportButtonName1.indexOf(' ') >= 0 ? pageLayoutData[0].exportButtonName1.replace(/\s+/g, '') : pageLayoutData[0].exportButtonName1}Permission`])
            setexportPermission2(responseDataJson.data[`export${pageLayoutData[0].hasOwnProperty('exportButtonName2') && pageLayoutData[0].exportButtonName2.indexOf(' ') >= 0 ? pageLayoutData[0].exportButtonName2.replace(/\s+/g, '') : pageLayoutData[0].exportButtonName2}Permission`])
            setexportPermission3(responseDataJson.data[`export${pageLayoutData[0].hasOwnProperty('exportButtonName3') && pageLayoutData[0].exportButtonName3.indexOf(' ') >= 0 ? pageLayoutData[0].exportButtonName3.replace(/\s+/g, '') : pageLayoutData[0].exportButtonName3}Permission`])
            setBulklistPermission(responseDataJson.data.bulkPicklistPermission)
            setMasterDeliveryPermission(responseDataJson.data.masterDeliveryPermission)
            setArray(array)
            setResponse(responseDataJson.data.data)
            if(!isEmpty(responseDataJson.data.data)) {
              const customerIds = dynamicParameters.customer_id == 14 || dynamicParameters.customer_id == 13;
              for (let [key, value] of Object.entries(responseDataJson.data.data)) {
                /*below condition is for pidilite delivery details */
                if(value?.status === "Cancelled"){
                  continue;
                }
                value.actions = <div>
                  {(pageLayoutData[1].title1 !== "Products") && (pageLayoutData[1].title1 !== "Inventory") && (value?.childData?.length > 0) ? <a onClick={(e) => openModalTreeView(e, value)}><i className="fa fa-expand"></i></a> : ''}
                  {(value.add == true || value[`add${pageLayoutData[0].hasOwnProperty('addButtonParentName') && pageLayoutData[0].addButtonParentName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonParentName.replace(/\s+/g, '') : pageLayoutData[0].addButtonParentName
                    }Permission`] === true) && <a onClick={(e) => opneParent(e, value)}><i className="fa fa-plus-square-o fa-add"></i></a>}
                  {(value.edit == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true) && <a onClick={(e) => editOpenModal(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {(value.del == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
                  }Permission`] === true) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value.editExtra == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildExtraName') && pageLayoutData[0].addButtonChildExtraName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildExtraName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildExtraName
                    }Permission`] === true) && <a onClick={(e) => editOpenModalExtra(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {responseDataJson.data.editPermission == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => editComponent(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a> : ''}
                  {responseDataJson.data.deletePermission == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => deleteparent1(e, value)}><i className="fa fa-trash-o fa-delete"></i></a> : ''}
                  {customerIds && pageLayoutData[1].title1 == "Delivery" ? (value.fifo_flag == 1) ? <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> : <i onClick={() => handleRefreshIcon(value.name)} className="fa fa-refresh + refresh-icon"></i>
                    : (value.download == true) && <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> }
                  {(value.restore == true) && <a onClick={(e) => restoreParent(e, value)}><i className="fa fa-recycle"></i></a>}
                  {(value.po_type === 'Reclamation PO') &&
                  <Tippy interactive={false} offset={[20, 10]} delay={50} placement={"top"} theme={'light'} animation='shift-toward' content={<div>
                  <h5 style={{ height: '20px', width: '8rem', fontSize: "15px" }}>{pageLayoutData[0].addButtonChildName}</h5></div>}>
                  <i className="fa fa-info-circle info-icon"></i></Tippy>}
                  {(value.master_delivery === 1 && value.DeleteMasterDeliveryPermission) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value?.tp_download === "1" && value.tp_id) && <i className="fa fa-file-pdf-o refresh-icon" aria-hidden="true" onClick={() => handleTpPdfDownload(value)} />}
                </div>
                  if(value.image){
                    value.image = <div>
                     <img src={value.image} alt="no img" width="50" height="50" />
                     </div>;
                   }
                }
              }
              
            setColumns(responseDataJson.data.columns);
            getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
            setproductsData(responseDataJson.data.data);
            setformValues(pageLayoutData[0].formValues);
            setInvValidation(responseDataJson.data.deliveryInventoryValidation);
            settotalrecords(responseDataJson.data.recordsTotal);
            setloadTableData(true);
            setSelectOption(
              Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
            );
          }
          else {
            setloadTableData(false);
            setError(true);
            setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
          }  
        }
        else {
          let responseData = await PostAPI(getURL, totalParams);
          if(responseData.status == 200){
            setError(false);
            let responseDataJson = responseData.data;
            for (let i = 0; i < responseDataJson.data.data.length; i++) {
              if (responseDataJson.data.data.hasOwnProperty["childData"] && responseDataJson?.data?.data[i]?.childData?.length === 0) {
                array.push(responseDataJson.data.data[i].name);
              }
            }
            setAddPermission(responseDataJson.data[`add${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName}Permission`])
            setAddPermission1(responseDataJson.data[`assign${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName}Permission`])
            setAddPermission2(responseDataJson.data[`add${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name}Permission`])
            setAddPermission3(responseDataJson.data[`add${pageLayoutData[0].hasOwnProperty('addButtonName4') && pageLayoutData[0].addButtonName4.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName4.replace(/\s+/g, '') : pageLayoutData[0].addButtonName4}Permission`])
            setAddPermission4(responseDataJson.data[`add${pageLayoutData[0].hasOwnProperty('addButtonName2') && pageLayoutData[0].addButtonName2.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName2.replace(/\s+/g, '') : pageLayoutData[0].addButtonName2}Permission`])
            setAddChildPermission(responseDataJson.data[`add${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName}Permission`])
            setimportPermission(responseDataJson.data[`import${pageLayoutData[0].hasOwnProperty('importButtonName') && pageLayoutData[0].importButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].importButtonName.replace(/\s+/g, '') : pageLayoutData[0].importButtonName}Permission`])
            setimportPermission1(responseDataJson.data[`import${pageLayoutData[0].hasOwnProperty('importButtonName1') && pageLayoutData[0].importButtonName1.indexOf(' ') >= 0 ? pageLayoutData[0].importButtonName1.replace(/\s+/g, '') : pageLayoutData[0].importButtonName1}Permission`])
            setimportPermission2(responseDataJson.data[`import${pageLayoutData[0].hasOwnProperty('importButtonName2') && pageLayoutData[0].importButtonName2.indexOf(' ') >= 0 ? pageLayoutData[0].importButtonName2.replace(/\s+/g, '') : pageLayoutData[0].importButtonName2}Permission`])
            setexportPermission(responseDataJson.data[`exportPermission`])
            setexportPermission1(responseDataJson.data[`export${pageLayoutData[0].hasOwnProperty('exportButtonName1') && pageLayoutData[0].exportButtonName1.indexOf(' ') >= 0 ? pageLayoutData[0].exportButtonName1.replace(/\s+/g, '') : pageLayoutData[0].exportButtonName1}Permission`])
            setexportPermission2(responseDataJson.data[`export${pageLayoutData[0].hasOwnProperty('exportButtonName2') && pageLayoutData[0].exportButtonName2.indexOf(' ') >= 0 ? pageLayoutData[0].exportButtonName2.replace(/\s+/g, '') : pageLayoutData[0].exportButtonName2}Permission`])
            setexportPermission3(responseDataJson.data[`export${pageLayoutData[0].hasOwnProperty('exportButtonName3') && pageLayoutData[0].exportButtonName3.indexOf(' ') >= 0 ? pageLayoutData[0].exportButtonName3.replace(/\s+/g, '') : pageLayoutData[0].exportButtonName3}Permission`])
            setBulklistPermission(responseDataJson.data.bulkPicklistPermission)
            setMasterDeliveryPermission(responseDataJson.data.masterDeliveryPermission)
            setArray(array)
            setResponse(responseDataJson.data.data)
            if(!isEmpty(responseDataJson.data.data)) {
              const customerIds = dynamicParameters.customer_id == 14 || dynamicParameters.customer_id == 13;
                for (let [key, value] of Object.entries(responseDataJson.data.data)) {
                  /*below condition is for pidilite delivery details */
                if(value?.status === "Cancelled"){
                  continue;
                }
                  value.actions = <div>
                  {(pageLayoutData[1].title1 !== "Products") && (pageLayoutData[1].title1 !== "Inventory") && (value?.childData?.length > 0) ? <a onClick={(e) => openModalTreeView(e, value)}><i className="fa fa-expand"></i></a> : ''}
                  {(value.add == true || value[`add${pageLayoutData[0].hasOwnProperty('addButtonParentName') && pageLayoutData[0].addButtonParentName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonParentName.replace(/\s+/g, '') : pageLayoutData[0].addButtonParentName
                    }Permission`] === true) && <a onClick={(e) => opneParent(e, value)}><i className="fa fa-plus-square-o fa-add"></i></a>}
                  {(value.edit == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true) && <a onClick={(e) => editOpenModal(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {(value.del == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButtonChildName') && pageLayoutData[0].addButtonChildName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildName
                    }Permission`] === true) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value.editExtra == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButtonChildExtraName') && pageLayoutData[0].addButtonChildExtraName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonChildExtraName.replace(/\s+/g, '') : pageLayoutData[0].addButtonChildExtraName
                    }Permission`] === true) && <a onClick={(e) => editOpenModalExtra(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a>}
                  {responseDataJson.data.editPermission == true || value[`edit${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => editComponent(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a> : ''}
                  {responseDataJson.data.deletePermission == true || value[`delete${pageLayoutData[0].hasOwnProperty('addButton3Name') && pageLayoutData[0].addButton3Name.indexOf(' ') >= 0 ? pageLayoutData[0].addButton3Name.replace(/\s+/g, '') : pageLayoutData[0].addButton3Name
                    }Permission`] === true
                    ? <a onClick={(e) => deleteparent1(e, value)}><i className="fa fa-trash-o fa-delete"></i></a> : ''}
                  {customerIds && pageLayoutData[1].title1 == "Delivery" ? (value.fifo_flag == 1) ? <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> : <i onClick={() => handleRefreshIcon(value.name)} className="fa fa-refresh + refresh-icon"></i>
                    : (value.download == true) && <a onClick={(e) => exportPdf(e, value.name)}><i className="fa fa-download-square-o fa-download"></i></a> }
                  {(value.restore == true) && <a onClick={(e) => restoreParent(e, value)}><i className="fa fa-recycle"></i></a>}       
                  {(value.po_type === 'Reclamation PO') &&
                  <Tippy interactive={false} offset={[20, 10]} delay={50} placement={"top"} theme={'light'} animation='shift-toward' content={<div>
                  <h5 style={{ height: '20px', width: '8rem', fontSize: "15px" }}>{pageLayoutData[0].addButtonChildName}</h5></div>}>
                  <i className="fa fa-info-circle info-icon"></i></Tippy>}
                  {(value.master_delivery === 1 && value.DeleteMasterDeliveryPermission) && <a onClick={(e) => deleteParent(e, value)}><i className="fa fa-trash-o fa-delete"></i></a>}
                  {(value?.tp_download === "1" && value.tp_id) && <i className="fa fa-file-pdf-o refresh-icon" aria-hidden="true" onClick={() => handleTpPdfDownload(value)} />}
                </div>
                  if(value.image){
                    value.image = <div>
                     <img src={value.image} alt="no img" width="50" height="50" />
                     </div>;
                   }
                }
              }
            setColumns(responseDataJson.data.columns);
            getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
            setproductsData(responseDataJson.data.data);
            settotalrecords(responseDataJson.data.recordsTotal);
            setloadTableData(true);
            setSelectOption(
              Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
            );
          }
          else {
            setloadTableData(false);
            setError(true);
            setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
          }
        }
        setloadTableData(true);
      }

    })()
  }, [pageLayoutData])

  useEffect(() => {
    if (globalLoadIndicator == '2' && cookies.get('pagetype_id') == 4
    && featureBlueprint.data.featureBlueprintymlData.pageTypes[0].pageTypeId == 4)
     {
     if((pageLayoutData[1].title1 && 
      pageLayoutData[1].title1 == featureBlueprint.data.featureBlueprintymlData.pageTypes[0].bodyLayout[1].title1)) {
      setPageLayoutData(pageLayoutDataContext);
      }
      else {
        if(pageLayoutData[1].title1 !== 'Location Types')
        setPageLayoutData(pageLayoutDataContext);
      }
    } else if (globalLoadIndicator == '1') {
      setPageLayoutData('undefined');
    }
  }, [globalLoadIndicator]);

  useEffect(() => {
    options.page = selectedValue;
    setpage(selectedValue);
  }, [selectedValue]);

  useEffect(() => {
    setSelectedValue(page);
  }, []);

  const onTop = () => {
    window.scrollTo(0, 0);
  }
  useEffect(() => {
    onTop()
  }, [page]);

  const options = {
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    sizePerPage: sizePerPage,
    page: page,
    totalSize: totalrecords
  }
  
  async function expandRowTable(key) {
    if (pageLayoutData[1].title1 === "Delivery") {
      const getActiveRow = productsData.filter(row => row.name === key)[0]
      if("parentData" in getActiveRow){
      setExpandTableLoader(false)
      setExpColumns(getActiveRow?.parentData?.columns);
      setExpData(getActiveRow?.parentData?.data)
      setExpRowTotalrecords(getActiveRow?.parentData?.length)
      }
      return;
    }
    setKey(key)
    setExpPage(1)
    setExpandTableLoader(true)
    let payLoad = {}
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint1
    if (pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      payLoad = { ...payLoad, ...extraParameteres }
    }
    if (pageLayoutData[1].subComponentsItems.firstTimeParameters !== null) {
      const firstTimeParameters = pageLayoutData[1].subComponentsItems.firstTimeParameters;
      payLoad = { ...payLoad, ...firstTimeParameters }
    }

    let fmData = serachFliterBoxData(values);
    payLoad = { ...payLoad, ...dynamicParameters,...fmData }

    for (let i = 0; i < response.length; i++) {
      if (response[i].name === key) {
        payLoad = {
          ...payLoad,
          specificProductId: response[i].productId,
          specificLocationId: response[i].locationId,
        }
      }
    }
    let responseData = await PostAPI(getURL, payLoad);
    if (responseData.status == 200) {
      let responseDataJson = await responseData.data;
      setExpandTableLoader(false)
      setExpColumns(responseDataJson.data.columns);
      setExpData(responseDataJson.data.data)
      setExpRowTotalrecords(responseDataJson.data.expandRowTotalrecords)
    }
    else {
      setError(true);
      setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
    }
  }

  async function expandChildRowTable(key) {
    if(pageLayoutData[1].title1 === "Delivery"){
      return;
    }
    setExpandChildTableLoader(true)
    setExpChildPage(1)
    let payLoad = {}
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint2
    if (pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      payLoad = { ...payLoad, ...extraParameteres }
    }
    if (pageLayoutData[1].subComponentsItems.firstTimeParameters !== null) {
      const firstTimeParameters = pageLayoutData[1].subComponentsItems.firstTimeParameters;
      payLoad = { ...payLoad, ...firstTimeParameters }
    }

    
    let fmData = serachFliterBoxData(values);
    payLoad = { ...payLoad, ...dynamicParameters,...fmData }


    for (let i = 0; i < expandData.length; i++) {
      if (expandData[i].name === key) {
        payLoad = {
          ...payLoad,
          ...fmData,
          specificProductId: expandData[i].productId,
          specificLocationId: expandData[i].locationId,
          mfg_date: expandData[i].mfg_in
        }
      }
    }
    let responseData = await PostAPI(getURL, payLoad);
    if (responseData.status == 200) {
      let responseDataJson = await responseData.data;
      setExpandChildTableLoader(false)
      setExpChildColumns(responseDataJson.data.columns);
      setExpChildData(responseDataJson.data.data)
      setExpChildRowTotalrecords(responseDataJson.data.recordsTotal)
      setKey1(key)
      setExpRes(expChildData);
    }
    else {
      setError(true);
      setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
    }
    
  }

  const handleTableChange1 = (event, { page, sizePerPage }) => {
    const currentIndex = (page - 1) * sizePerPage;
    setExpPage(page);
    setExpSizePerPage(sizePerPage);
    handleLatestTableData1(page);
}

async function handleLatestTableData1(page) {
    let startFrom = 0;
    let cpage = 0
    const searchFormData = {};
    let payLoad = {}
    let totalParams;
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint1;
    if (pageLayoutData[1].subComponentsItems.extraParameters !== null) {
        const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
        totalParams = { ...totalParams, ...extraParameteres }
    }
    totalParams = { ...totalParams, ...dynamicParameters }
    let fmData = serachFliterBoxData(values);
    if (page == 1) {
        let startFrom = 0;
        totalParams.start_from = startFrom;
    } else {
        cpage = page - 1;
        startFrom = cpage * expSizePerPage;
        totalParams.start_from = startFrom;
    }
    let newObj = { ...fmData, ...totalParams}
    let newestObjSearch;
    let newestObj = { ...newObj, index: page }
    for (let i = 0; i < response.length; i++) {
      if (response[i].name === key) {
        payLoad = {
          ...payLoad,
          specificProductId: response[i].productId,
          specificLocationId: response[i].locationId,
        }
      }
    }
  newestObjSearch = {
    ...newestObj,
    ...payLoad,
  }
    let responseData = await PostAPI(getURL, newestObjSearch);
    let responseDataJson = responseData.data;
    if (responseData.status == 200) {
        setError(false);
        let responseDataJson = responseData.data;
        setExpColumns(responseDataJson.data.columns);
        setExpData(responseDataJson.data.data)
        setExpRowTotalrecords(responseDataJson.data.expandRowTotalrecords)
    }
    else {
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
    }

}

const handleTableChange2 = (event, { page, sizePerPage }) => {
  const currentIndex = (page - 1) * sizePerPage;
  setExpChildPage(page);
  setExpChildSizePerPage(sizePerPage);
  handleLatestTableData2(page);
}

async function handleLatestTableData2(page) {
  let startFrom = 0;
  let cpage = 0
  const searchFormData = {};
  let payLoad = {}
  let totalParams;
  let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint2
    if (pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = { ...totalParams, ...extraParameteres }
    }
  totalParams = { ...totalParams, ...dynamicParameters }
  let fmData = serachFliterBoxData(values);
  if (page == 1) {
      let startFrom = 0;
      totalParams.start_from = startFrom;
  } else {
      cpage = page - 1;
      startFrom = cpage * expChildSizePerPage;
      totalParams.start_from = startFrom;
  }
  let newObj = { ...fmData, ...totalParams}
  let newestObjSearch;
  let newestObj = { ...newObj, index: page }
  for (let i = 0; i < expandData.length; i++) {
    if (expandData[i].name === key1) {
      payLoad = {
        ...payLoad,
        specificProductId: expandData[i].productId,
        specificLocationId: expandData[i].locationId,
        mfg_date: expandData[i].mfg_in
      }
    }
  }
newestObjSearch = {
  ...newestObj,
  ...payLoad,
  element: searchInputValue,
}
  let responseData = await PostAPI(getURL, newestObjSearch);
  let responseDataJson = responseData.data;
  if (responseData.status == 200) {
      setError(false);
      let responseDataJson = responseData.data;
      setExpChildColumns(responseDataJson.data.columns);
      setExpChildData(responseDataJson.data.data)
      setExpChildRowTotalrecords(responseDataJson.data.recordsTotal)
      setExpRes(expChildData);
  }
  else {
      setError(true);
      setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
  }

}
  const alertNodeInfo = ({ node, path, treeIndex }) => {
    const objectString = Object.keys(node)
      .map(k => (k === "children" ? "children: Array" : `${k}: '${node[k]}'`))
      .join(",\n   ");
  
    global.alert(
      "Info passed to the button generator:\n\n" +
        `node: {\n   ${objectString}\n},\n` +
        `path: [${path.join(", ")}],\n` +
        `treeIndex: ${treeIndex}`
    );
  };

const updateTreeData = (data) => {
     setChangeTreeValue(true);
     setTreevalue([...data]);
    setTimeout(() => {
    }, 2000);
  }

  const paginationOption = {
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    sizePerPage: expSizePerPage,
    page: expPage,
    totalSize: expandRowTotalrecords
  }

  const expPaginationOption = {
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    sizePerPage: expChildSizePerPage,
    page: expChildPage,
    totalSize: expandChildRowTotalrecords
  }

  const expandRow = {  
    renderer: ( row ) => (
      <div style={row.hasOwnProperty('childData') && count > 0 ? {height: count * 62} : expandTableLoader ? {height : 110} : {height:30}}>
      {(row.hasOwnProperty('childData') && childRow != row.name ) && setChangeTreeValue(false)}      
      {(row.hasOwnProperty('childData') && changeTreeValue == false ) &&  setTreevalue(row.childData) }
      {(row.hasOwnProperty('childData') && changeTreeValue == true ) && setTreevalue(treevalue) }
      { row.hasOwnProperty('childData') && setChildRow(row.name)}
      <p>{row.hasOwnProperty('childData') && row.attributeSetName }</p>
      {row.hasOwnProperty('childData') && Object.keys(row.childData).length > 0 ? 
        <SortableTree
        treeData={ treevalue }
        onChange={ updateTreeData }
        theme={FileExplorerTheme}
        isVirtualized={true}
          canDrag= { false }
          compact = { false }
          noContextMenu = { true }
          
          generateNodeProps={rowInfo => ({
            listIndex: 0,
            lowerSiblingCounts: [],
            buttons: [
              ( rowInfo.node.add == true ) ?
              <button
              className="btn btn-outline-info"
              style={{
                verticalAlign: "middle",
                borderRadius: '15px'
              }}
              onClick={() => addChild(row,rowInfo)}
              >
                    <i className="fa fa-plus-square-o fa-add"></i>
                  </button>
                  : '',
                  ( rowInfo.node.edit == true || rowInfo.node[`edit${
                    pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
                    }Permission`] === true  ) ?
                  <button
                    className="btn btn-outline-info"
                    style={{
                      verticalAlign: "middle",
                      borderRadius: '15px'
                    }}
                    onClick={() => opneEditParent(row,rowInfo)}
                  >
                    <i className="fa fa-pencil-square-o"></i>
                  </button>
                  : '',
                  ( rowInfo.node.del == true || rowInfo.node[`delete${
                    pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
                    }Permission`] === true ) ?
                  <button
                  className="btn btn-outline-danger"
                  style={{
                    verticalAlign: "middle",
                    borderRadius: '15px'
                  }}
                  onClick={() => deleteOpenModal(row,rowInfo)}
                >
                  <i className="fa fa-trash-o"></i>
                </button>
                  : '',
                  ( rowInfo.node.delParent == true ) ?
                  <button
                  className="btn btn-outline-danger"
                  style={{
                    verticalAlign: "middle",
                    borderRadius: '15px'
                  }}
                  onClick={() => deleteParentPassword(row,rowInfo)}
                >
                  <i className="fa fa-trash-o"></i>
                </button>
                  : '',
                  ( rowInfo.node.delChild == true ) ?
                  <button
                  className="btn btn-outline-danger"
                  style={{
                    verticalAlign: "middle",
                    borderRadius: '15px'
                  }}
                  onClick={() => deleteChildPassword(row,rowInfo)}
                >
                  <i className="fa fa-trash-o"></i>
                </button>
                  : '',
                  ( rowInfo.node.restore == true ) ?
                  <button
                    className="btn btn-outline-info"
                    style={{
                      verticalAlign: "middle",
                      borderRadius: '15px'
                    }}
                    onClick={() => restoreChild(row,rowInfo)}
                  >
                    <i className="fa fa-recycle"></i>
                  </button>
                  : '',
                  ( rowInfo.node.search == true ) ?
                  <button
                    className="btn btn-outline-info"
                    style={{
                      verticalAlign: "middle",
                      borderRadius: '15px'
                    }}
                    onClick={() => searchableChild(row,rowInfo)}
                  >
                    <i className="fa fa-search-minus"></i>
                  </button>
                  : '',
                  ( rowInfo.node.search == false ) ?
                  <button
                    className="btn btn-outline-grey"
                    style={{
                      verticalAlign: "middle",
                      borderRadius: '15px'
                    }}
                    onClick={() => searchableChild(row,rowInfo)}
                  >
                    <i className="fa fa-search-plus"></i>
                  </button>
                  : '',
                ]
              })}
            />
      :
            (row.hasOwnProperty("bin_location") === false) ?
            expandTableLoader ? 
                <div className="text-center" style={{...centeredDiv, height:'13vh'}}><LoadingSpinner /></div>
            :
            <div style={{ height: "1em" }} className={`${pageLayoutData[1].title1 === "Delivery" ? "delivery-pagination" : ""}`} >
                {pageLayoutData[1].title1 === "Delivery" ? null :<h4>Ageing {pageLayoutData[1].title2}</h4>}
                <BootstrapTable
                  remote
                  striped
                  hover
                  condensed
                  keyField="name"
                  columns={expandColumns}
                  data={expandData}
                  bordered={true}
                  expandRow={cookies.get("customer_id") === '14' || (cookies.get("customer_id") === '15' && pageLayoutData && pageLayoutData[1].title1 !== "Delivery")? "" : expandChildRow}
                  pagination={paginationFactory(paginationOption)}
                  onTableChange={handleTableChange1}
                  noDataIndication={`${t("no_data")} `}
                  wrapperClasses="table-responsive overflow-class"
                />
              </div>
              
      :
        <span>No data</span>}
      </div> 
      ),

    nonExpandable: array,
    onExpandable: false,
    showExpandColumn: true,
    onlyOneExpanding: true,
    expandByColumnOnly: false,
    onExpandAll: (isAllExpand, result, e) => {
      setshowExpandColumn(false)
    },
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      setshowExpandColumn(true)
    },
    expandColumnRenderer: ({ expanded, expandable, rowKey}) => {
      if (expanded) {
        if (productsData?.length > 0) {
          for(let product of productsData){
            if (product.name === rowKey) {
              if (!("childData" in product)) {
                expandRowTable(rowKey)
                break;
              }
            }
          }
        }
        return (
          <div>
          <i className="fa fa-chevron-down"></i>
          </div>
        );
      }
      if(expandable) {
        return (
          <i className="fa fa-chevron-right"></i>
        )
      }
      else {
        return null
      }
  }
  };
    
    
  const expandChildRow = {
    renderer: (row) => (
      (expandChildTableLoader) ? 
        <div className="text-center" style={centeredDiv}><LoadingSpinner /></div>
        :
        <div style={row.hasOwnProperty("childData") && count > 0 ? {height: count * 62} : expandTableLoader ? {height : 110} :  {height : 30}}>
      {(row.hasOwnProperty("childData") && childRow != row.name ) && setChangeTreeValue(false)}      
      { (row.hasOwnProperty("childData") && changeTreeValue == false ) &&  setTreevalue(row.childData) }
      { (row.hasOwnProperty("childData") && changeTreeValue == true ) && setTreevalue((prevState => prevState)) }
      { row.hasOwnProperty("childData") && setChildRow(row.name)}
      <p>{row.hasOwnProperty("childData") && row.attributeSetName }</p>
        {row.hasOwnProperty("childData") && Object.keys(row.childData).length > 0 ? 
        <SortableTree
          treeData={treevalue}
          onChange={updateTreeData}
          theme={FileExplorerTheme}
          isVirtualized={true}
          canDrag={false}
          compact={false}
          noContextMenu={true}
            /> :  
        <>
          { pageLayoutData[1].title1 === "Delivery" ? <p className="centered-data">No Data</p> : (
        <>
       <h4>BinLocation {pageLayoutData[1].title2}</h4>
        <BootstrapTable
          remote
          striped
          condensed
          keyField="name"
          columns={expChildColumns}
          data={expChildData}
          bordered={true}
          pagination={paginationFactory(expPaginationOption)}
          onTableChange={handleTableChange2}
          noDataIndication="No data found"
          wrapperClasses="table-responsive overflow-class"
          headerClasses="grid-header"
        />
    </>
   ) }
        </>
      }</div>
    ),
    nonExpandable: array,
    onExpandable: false,
    showExpandColumn: true,
    onlyOneExpanding: true,
    expandByColumnOnly: true,
    onExpandAll: (isAllExpand, result, e) => {
      setshowExpandColumn(false)
    },
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
      }
    },
    expandColumnRenderer: ({ expanded, expandable, rowKey}) => {
      if (expanded) {
        expandChildRowTable(rowKey)
        return (
          <div>
          <i className="fa fa-chevron-down"></i>
          </div>
        );
      }
      if(expandable) {
        return (
          <i className="fa fa-chevron-right"></i>
        )
      }
      else {
        return null
      }
  }
  };
  const openImport = () => {
    setmodalType(`${t("import")}`);
    setModalWidth(pageLayoutData[0].importButtonItems.className);
    setModalTitle(pageLayoutData[0].importButtonName);
    setModalformValues(pageLayoutData[0].importButtonItems.formValues);
    setSaveUrl(pageLayoutData[0].importButtonItems.saveApiEndPoint);
    setshowModal(true);
  }
  const openImport1 = () => {
    setmodalType(`${t("import")}`);
    setModalWidth(pageLayoutData[0].importButtonItems1.className);
    setModalTitle(pageLayoutData[0].importButtonName1);
    setModalformValues(pageLayoutData[0].importButtonItems1.formValues);
    setSaveUrl(pageLayoutData[0].importButtonItems1.saveApiEndPoint);
    setshowModal(true);
  }
  const openImport2 = () => {
    setmodalType(`${t("import")}`);
    setModalTitle(pageLayoutData[0].importButtonName2);
    setModalformValues(pageLayoutData[0].importButtonItems2.formValues);
    setSaveUrl(pageLayoutData[0].importButtonItems2.saveApiEndPoint);
    setshowModal(true);
  }
  async function exportFile(e,name) {
    setIsLoader(true)
    e.preventDefault();
    let val;
    if(pageLayoutData[0].formValues) 
      val = pageLayoutData[0].formValues;
    else
      val = 'undefined';
    const searchFormData = {};
    let requiredValues = {
      user_id:cookies.get('user_id'),
      customer_id:cookies.get('customer_id'),
      email:localStorage.getItem('email'),
      language:language
    }
    const getURL = (pageLayoutData[0].exportApiEndPoint) ? pageLayoutData[0].exportApiEndPoint 
    : (name === pageLayoutData[0].exportButtonName1) ? pageLayoutData[0].exportApiEndPoint1 
    : (name === pageLayoutData[0].exportButtonName2) ?  pageLayoutData[0].exportApiEndPoint2
    : (name === pageLayoutData[0].exportButtonName3) ?  pageLayoutData[0].exportApiEndPoint3
    : 'not found';
    let newgetURL,getresponse,dataObject;
    dataObject = {
      ...requiredValues
    }
    if(val !== 'undefined') {
      let fmData = serachFliterBoxData(values);
      let customerId = cookies.get('customer_id');
      if (customerId == 13 && fmData.from_date != null && fmData.to_date == null) {
        swal({ title: 'Failed', text: 'Please select to date', icon: "error", button: "OK" })
        return
      }
      if (customerId == 13 && (fmData.from_date != null && fmData.to_date == null) || fmData.from_date == null && fmData.to_date != null) {
        swal({ title: 'Failed', text: 'Please select from date', icon: "error", button: "OK" })
        return
      }
      dataObject = {...dataObject, ...fmData}
      if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
        const paramString = new URLSearchParams(dataObject);
        newgetURL = (`${getURL}?${paramString.toString()}`);
        getresponse = await FetchAPI(newgetURL);
      }
      else {
        getresponse = await PostAPI(getURL, dataObject);
      }
    } else {
      if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
        const paramString = new URLSearchParams(requiredValues);
        newgetURL = (`${getURL}?${paramString.toString()}`);
        getresponse = await FetchAPI(newgetURL);
        let getresponseJson = await getresponse.json()
        window.location.href = getresponseJson?.data?.Location
      }
      else {
        getresponse = await PostAPI(getURL, requiredValues);
      }
    }
    if(getresponse.status == 200){
      setIsLoader(false);
      swal({title:`${t("alerts.your_request_under_process")}`, text:`${t("alerts.receive_email")}`, icon:"success", button:`${t("alerts.ok")}`})
      name && (window.location.href = getresponse?.data?.data?.Location)
    }
    else{
    setIsLoader(false)
      swal({title:`${t("alerts.something_went_wrong1")}`, text:`${t("alerts.download_again")}`, icon:"error", button:`${t("alerts.ok")}`})
    }
  }

  const handlePageChange = (e) => {
    setSelectedValue(e.target ? e.target.value : e);
    handleLatestTableData(e.target ? e.target.value : e);
  };

  const handleOnSelectRow = (row,isSelect) => {
    if(isSelect){
      setIsSelectedRow([...isSelectedRow,row.name])
    }else{
      setIsSelectedRow(isSelectedRow.filter(selected => selected !== row.name))
    }
  }
  
  const getNonSelectable = () => {
    if(productsData?.length > 0){
       return productsData.map(product => {
        if(product.status !== "Pending"){
          return product.name
        }
      })
    }
  }

  const selectRow = {
    mode: 'checkbox',
    onSelect: handleOnSelectRow,
    nonSelectable: getNonSelectable(),
    hideSelectAll: true,
    selected: isSelectedRow
  };

  const handleMasterDelivery = async() => {
    try{
      const getSelectedRows = productsData.filter(delivery => delivery.master_delivery === 1)
      for(let value of getSelectedRows){
        if(isSelectedRow.includes(value.name)){
          getStatusAlert({status: 0,message: "Master delivery already created for selected deliveries."})
          return;
        }
      }
      const payload = {
        delivery_ids: isSelectedRow,
        user_id:cookies.get("user_id"),
      }
      const getURL = pageLayoutData[0].exportEndPoint2;
      setIsLoader(true);
      const response = await PostAPI(getURL, payload);
      setIsLoader(false);
      if(response?.data?.data?.status !== 0){
        setIsSelectedRow([]);
      };
      getStatusAlert({
        status: response?.data?.data?.status,
        message: response?.data?.data?.message,
        reCallGrid: getLatestTableData,
    })
      
    }catch(e){
      console.log(e)
    }
  }
  
  const handleSelectRow = async () => {
    try{
      const getSelectedRows = productsData.filter(delivery => delivery.master_delivery === 1)
      let count = 0
      for(let value of getSelectedRows){
        if(isSelectedRow.includes(value.name)){
          count++
          if(count === 2){
            getStatusAlert({status: 0,message: "Please select only one master delivery."})
            return;
          }
        }
      }
    const payload = {
      delivery_ids: isSelectedRow
    }
    const getURL = pageLayoutData[0].exportEndPoint1;
    const responseData = await PostAPI(getURL, payload);
    const url = responseData.data.data
    handleLatestTableData(page)
    setIsSelectedRow([])
    const link = document.createElement('a');
    link.target = '_self';
    link.href = url;
    link.setAttribute("download", url);
    link.click();
    } catch (e) {
      console.log(e)
    }
  } 

  return (
    (pageLayoutData != 'undefined' && cookies.get('pagetype_id') == 4) ?
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12} style={{ marginTop: '0px' }}>
              <Card style={{ fontSize: '12px' }}
                title={(pageLayoutData[1].title1) ? pageLayoutData[1].title1 : ''}
                title2={( pageLayoutData[1].title2) ? pageLayoutData[1].title2 : ''}
                content={
                  <div>
                  {showParentContent ?
                  <ToolkitProvider
                    keyField="id"
                    data={productsData}
                    columns={columns}
                    search
                    exportCSV
                  >
                    {
                      props => (
                        <div>
                          <MDBRow>
                          {(pageLayoutData[0].searchOption === true) ? <MySearch {...props.searchProps} /> : ''}
                            
                            {/* <MDBCol md="6" className="mb-6">
                              {<SearchBar {...props.searchProps} />}
                              <ClearSearchButton {...props.searchProps} />
                            </MDBCol> */}
                            <MDBCol md="12" className="mb-12" style={{float: 'right'}}>
                              <div style={{ float: 'right',right:'0' }}>
                                {/* <MyExportCSV {...props.csvProps} /> */}
                                {/* <ExportCSVButton {...props.csvProps}>Export CSV!!</ExportCSVButton> */}
                                {masterDeliveryPermission && <ButtonField color="info" disabled={isSelectedRow?.length < 2}  submit={(e) => handleMasterDelivery(e)} BName={"Master Delivery"} />}
                                {bulkPicklistPermission && <ButtonField color="info" disabled={isSelectedRow?.length < 1}  submit={(e) => handleSelectRow(e)} BName={"Bulk Picklist"} />}
                                {(pageLayoutData[0].exportButton === true ||exportPermission === true)  ? <ButtonField color="info" submit={(e) => exportFile(e)} BName={`${t("export_csv")} `} /> : ''}
                                {(pageLayoutData[0].exportButton1 === true || exportPermission1 === true) ? <ButtonField color="info" submit={(e) => exportFile(e,pageLayoutData[0].exportButtonName1)} BName={`${t("export")} `+ pageLayoutData[0].exportButtonName1} /> : ''}
                                {(pageLayoutData[0].exportButton2 === true || exportPermission2 === true) ? <ButtonField color="info" submit={(e) => exportFile(e,pageLayoutData[0].exportButtonName2)} BName={`${t("export")} `+ pageLayoutData[0].exportButtonName2} /> : ''}
                                {(pageLayoutData[0].exportButton3 === true || exportPermission3 === true) ? <ButtonField color="info" submit={(e) => exportFile(e,pageLayoutData[0].exportButtonName3)} BName={`${t("export")} `+ pageLayoutData[0].exportButtonName3} /> : ''}
                                {((pageLayoutData[0].addButton === true || addPermission === true) && pageLayoutData[0].addButtonType !== 'wizard') ? <ButtonField color="info" submit={() => open()} BName={`${t("add")} `+ pageLayoutData[0].addButtonName} /> : ''}
                                {(pageLayoutData[0].addButtonChild === true || addChildPermission === true) ? <ButtonField color="info" submit={() => openChild()} BName={`${t("add")} `+ pageLayoutData[0].addButtonChildName} /> : ''}
                                {/*Assign Category*/}{((pageLayoutData[0].addButton === true || addPermission1 === true) && pageLayoutData[0].addButtonType == 'wizard') ?  <ButtonField color="info" submit={() => openComponent()} BName={`${t("assign")} `+ pageLayoutData[0].addButtonName} /> : ''}
                                {/*Add Product*/}{((pageLayoutData[0].addButton2 === true || addPermission2 === true) && pageLayoutData[0].addButtonType == 'wizard') ?  <ButtonField color="info" submit={() => openComponent1()} BName={`${t("add")} `+ pageLayoutData[0].addButton3Name} /> : ''}
                                {/*Add Location*/}{(pageLayoutData[0].addButton3 === true || addPermission3 === true) ? <ButtonField color="info" submit={() => openLocation()} BName={`${t("add")} `+ pageLayoutData[0].addButtonName4} /> : ''}
                                {/*Add BusinessUnit*/}{(pageLayoutData[0].addButton4 === true || addPermission4 === true) ? <ButtonField color="info" submit={() => openBusinessUnit()} BName={`${t("add")} `+ pageLayoutData[0].addButtonName2} /> : ''}
                                {(pageLayoutData[0].filterStatus === true) ? <ButtonField color="info" key="Filter" submit={() => setshowFilter(!showFilter)} BName={`${t("filter")} `} /> : ''}
                                {(pageLayoutData[0].importButton === true || importPermission === true) ? <ButtonField color="info" submit={() => openImport()} BName={`${t("import")} `+ pageLayoutData[0].importButtonName} /> : ''}
                                {(pageLayoutData[0].importButton1 === true || importPermission1 === true) ? <ButtonField color="info" submit={() => openImport1()} BName={`${t("import")} `+ pageLayoutData[0].importButtonName1} /> : ''}
                                {(pageLayoutData[0].importButton2 === true || importPermission2 === true) ? <ButtonField color="info" submit={() => openImport2()} BName={`${t("import")} `+ pageLayoutData[0].importButtonName2} /> : ''}
                                {showModal ?
                                  <ModalBox
                                    key={ pageLayoutData[0].featureId }
                                    showModal={showModal}
                                    titlePreFix = { modalType }
                                    modalWidth = { modalWidth}
                                    uniqueid={ uniqueid }
                                    title={ modalTitle }
                                    title1 = {title1}
                                    formValue={ ModalformValues }
                                    addURL=  { saveUrl } 
                                    getURL={ modalgetURL }
                                    product_id_old = {productId}
                                    delivery_id = {deliveryId}
                                    commonTitle = {commonTitle}
                                    location_type_id = {locationTypeId}
                                    location_id = {locationId}
                                    permission = {invValidation}
                                    recallMehod = { getLatestTableData }
                                    drpdwnApi = { dropDownApi }
                                    extraId = {extraId}
                                    wareId = {wareId}
                                    headers = {headers}
                                    table = {table}
                                    val1 = {val1}
                                    val2 = {val2}
                                    dyn_template = {pageLayoutData[0].importDynamicTemplate}
                                    line = {line}
                                    extracall={ instantValuesUpdateFilterBox }
                                    featureTitle= {i18n.language === "chi" ? pageLayoutData[1].title1En : pageLayoutData[1].title1}
                                    hide={close} />
                                  : ''}
                                  {ShowModald3 ?
                                  <ModalTreeBox
                                    key={ pageLayoutData[0].featureId }
                                    showModal={ShowModald3}
                                    treeModalWidth= {pageLayoutData[0].treeModalWidth}
                                    treeHeight= {pageLayoutData[0].treeHeight}
                                    treeWidth= {pageLayoutData[0].treeWidth}
                                    treeLineHeight= {pageLayoutData[0].treeLineHeight}
                                    titlePreFix = { modalType }
                                    title={ modalTitle }
                                    getURL={ modalgetURL }
                                    hide={close} />
                                  : ''}
                              </div>
                            </MDBCol>
                          </MDBRow>
                          {showFilter ?
                            <FilterBox
                             key="FilterBox" 
                             setSelectChildValue={setSelectChildValue}
                             title={pageLayoutData[1].title1}
                             setformValues = { setformValues }
                             formValue={formValues} 
                             filteredExport = {filteredExport}
                             filteredExport2 = {filteredExport2}
                             change={inputChangedHandler} 
                             searchClick={(e) => searchTableData(e)} 
                             clearClick={clearTableData}
                             validate={validator}
                             exportFilterButton={pageLayoutData[0].exportFilterButton === true ? true : false}
                             dropDownApi = {pageLayoutData[0].hasOwnProperty('filterEndPoint') ? pageLayoutData[0].filterEndPoint+'?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id')+'&userLocation_id='+ cookies.get('userLocation_id')+ '&userRole_name='+ cookies.get('userRole_name') +'&language='+language + '&start_from='+ headerData.start_from : 'not found' } 
                             />
                            : ''}
                          {(loadTableData && cookies.get('pagetype_id') == 4)?
                          <div className={`${totalQuantities?.length > 0 ? "show-total-qty" : ""}`} >
                          <BootstrapTable
                            remote
                            striped
                            hover
                            condensed
                            keyField="name"
                            data={ productsData }
                            columns={ columns }
                            bordered={false}
                            rowStyle={rowStyle}
                            expandRow={(pageLayoutData[1].title1 == 'Inventory' &&  cookies.get('customer_id') === '16') ? '' : expandRow }
                            pagination={paginationFactory({
                              ...options,
                              page: Number(selectedValue),
                            })}
                            onTableChange={handleTableChange}
                            noDataIndication={`${t("no_data")} `}
                            wrapperClasses="table-responsive overflow-class"
                            selectRow={ (pageLayoutData[1].title1 === "Delivery" && cookies.get("customer_id") == 15) ? selectRow : undefined}
                          />
                              {
                                totalQuantities?.length > 0 && (
                                  <div className="report-qty">
                                    {totalQuantities.map(record => (
                                      <div>{`TOTAL ${record.name}`}&nbsp; <span className="report-qty-color" > {`: ${record.count}`}</span></div>
                                    ))}
                                  </div>
                                )
                              } 
                          {selectOption > 0 && (
                                <div
                                  class="Dropdown"
                                  style={{
                                    marginTop: "-45px",
                                    position: "absolute",
                                    fontSize: "13px",
                                  }}
                                >
                                         <p style={{ float: "left", fontSize: "13px" }}>{t("Page No:")}</p>

                                  <select
                                    onChange={handlePageChange}
                                    value={selectedValue}
                                  >
                                    {Array.from(Array(selectOption), (e, i) => {
                                      return (
                                        <option key={i + 1} value={i + 1}>
                                          {i + 1}
                                        </option>
                                      );
                                    })}
                                  </select>
                                </div>
                              )}
                              {isLoader===true&&<div className="beat-loader" ><BeatLoader  color={"#3C423C"} /></div>}
                           </div>
                            : <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            { error ?   
                              <h4> { errorMsg } </h4> 
                              :
                              <Grid fluid>
                                <div className="text-center"><LoadingSpinner /></div>
                              </Grid>
                            }
                            </div>}

                        </div>
                      )}
                  </ToolkitProvider>
                :
                <div>
                     {renderComponent && 
                     <Wizard 
                       setShowParentContent={setShowParentContent} 
                       pageLayoutData={ModalformValues}
                       pageLayoutData1={pageLayoutData[0]} 
                       pageLayoutData2 = {pageLayoutData[1].subComponentsItems}
                       addURL={pageLayoutData[1].subComponentsItems.saveApiEndPoint}
                       getURL={modalgetURL}
                      uniqueId={uniqueId}
                      imagePath={imagePath}
                       locationDropDownAPI={pageLayoutData[1].subComponentsItems.hasOwnProperty('getLocationDropdowns') ? pageLayoutData[1].subComponentsItems.getLocationDropdowns+'?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id') : 'not found' }
                       dropDwnApi = {dropDownApi}
                      featureName={i18n.language === "chi" ? pageLayoutData[0].addButtonNameEn :  pageLayoutData[0].addButtonName} 
                       commonTitle = {commonTitle}
                       titlePreFix = { modalType } 
                       recallMethod= { getLatestTableData }
                       showParentContent = {showParentContent}
                       setformValues = {setformValues}
                       setModalformValues = {setModalformValues}
                     />}
                     
                   </div>
                }
                </div>
                }
              />
            </Col>
          </Row>
        </Grid>


      </div>
      : <div className="content">
      <Grid fluid>
        <div className="text-center" style={{ margin:"80px" }}><LoadingSpinner /></div>
      </Grid>
    </div>
  );
}

export default Role;